var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "3.812 -325.881 743.934 1077.438",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 380.159851, 206.166199)",
    id: "cef9b2b1-1e64-4c17-aa48-f7f1deb00c72"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 380.159851, 206.166199)",
    id: "48a08f04-7a91-49cb-95cf-eaba790805ee"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    width: 1080,
    height: 1080,
    rx: 247.746,
    ry: 247.746
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.97, 0, 0, 2.97, 823.159851, 332.306213)",
    id: "d146674c-f0b4-49a4-827d-a7d7b446eabb"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 94.539848, 732.776184)",
    id: "ed6ed249-abcf-4989-8de7-3bf027c022be"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.72, 0, 0, 1.72, 832.529846, 206.166199)",
    id: "ed6ed249-abcf-4989-8de7-3bf027c022be"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 680.659851, 36.576206)",
    id: "60a741ea-f33c-4c50-af0a-d08e72d1283c"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 0.54, 694.069824, 85.246185)",
    id: "68559431-94ce-4f53-8eed-c723eb5e157a"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(13.64, 0, 0, 13.64, 380.159851, 206.166199)",
    id: "ca37b67e-a5a8-4921-a886-10283c1a98cd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6, 0, 0, 6, 376.144531, 200.208878)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4.03, -28.42)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(239,162,69)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-94.03, -61.58)",
    d: "M 73 1 C 88.354225 1 103.708458 1 119.547012 1.380494 C 121.025085 2.866886 122.018829 3.972784 123.18354 5.357315 C 125.230537 7.095388 127.106567 8.554827 129.186707 10.301064 C 130.913116 11.072486 132.435455 11.557108 134.035645 12.381042 C 137.749664 17.138935 141.385818 21.557516 145.170441 26.273907 C 146.500916 27.399267 147.682953 28.226818 148.886612 29.442427 C 148.951569 30.868919 148.994888 31.907356 149.176697 33.221748 C 150.544601 34.018852 151.774048 34.540001 153.272217 35.075905 C 153.894882 35.128605 154.24881 35.166546 154.650818 35.546936 C 154.720551 36.578991 154.742218 37.268597 154.421814 38.005692 C 153.424698 38.86356 152.039368 40.087349 152.227814 40.420258 C 154.072662 43.679272 156.179901 46.789761 158.286758 50.128426 C 158.360977 50.314377 158.409042 50.711918 158.226715 51.048649 C 157.731049 53.57642 157.417709 55.767456 157.07724 58.367123 C 157.069016 59.867306 157.087921 60.958866 157.102448 62.37722 C 157.088486 63.139675 157.078903 63.575336 156.807312 64.151703 C 156.030838 64.879936 155.516403 65.467468 154.602875 66.056732 C 153.140121 66.047195 152.076447 66.035927 150.774216 65.781059 C 144.773682 56.326813 136.625504 56.440849 131.416443 65.750023 C 130.456177 67.466118 128.759369 68.840759 128.083832 70.630203 C 126.826324 73.961227 125.377419 77.472702 125.333954 80.925758 C 125.301781 83.481918 126.545746 87.245697 131.476196 85.028862 C 137.929306 85.146591 143.915253 85.276489 150.008484 85.727951 C 149.391159 89.33017 148.66655 92.610809 147.910751 96.232964 C 147.802994 97.024857 147.72644 97.475235 147.30072 97.960312 C 145.597183 99.294823 144.138275 100.504639 142.918884 101.9207 C 141.781143 103.241966 141.042526 104.912842 139.877884 106.204025 C 134.563675 112.095551 128.931808 117.55616 120.752579 119.303398 C 118.531754 119.777817 116.348038 120.425957 114.074219 120.669464 C 113.93914 119.905312 113.877144 119.466064 113.923065 118.628601 C 114.025764 117.133484 114.020531 116.036575 114.045792 114.556 C 114.035614 113.147957 113.994926 112.123573 114.036163 110.746109 C 114.123436 109.676414 114.128784 108.959816 114.394745 107.938751 C 114.437225 98.115875 114.219101 88.59745 114.173302 78.700569 C 114.469994 72.377068 114.741669 66.428505 114.599693 60.489834 C 114.569756 59.237926 113.023018 58.022282 112.020897 56.506767 C 110.85257 55.504898 109.838524 54.786194 108.594147 53.853668 C 107.588539 53.464569 106.813278 53.289288 105.748291 52.964764 C 104.363701 52.12487 103.268829 51.434219 102.168991 50.439285 C 101.515427 49.140785 100.866837 48.146564 100.513916 47.008865 C 104.891937 42.100586 104.352264 39.235176 99.23941 37.468369 C 99.636574 37.016441 99.872055 36.766197 100.273087 36.470661 C 100.34539 35.939617 100.252151 35.453861 100.162575 34.705963 C 100.100624 34.281818 100.035011 34.119823 99.906403 33.719883 C 99.705742 33.155884 99.467552 32.941395 99.175598 32.863949 C 99.222359 32.889427 99.271584 32.794983 99.231339 32.448921 C 97.549477 30.323978 95.90786 28.545103 94.197014 26.734741 C 94.127777 26.703255 94.054428 26.836523 93.822884 26.548317 C 87.939743 26.148266 86.391998 28.410381 86.806107 36.277451 C 86.460243 37.108463 86.234039 37.664257 85.766724 38.35265 C 85.324615 38.982529 85.123627 39.479809 84.753387 40.291435 C 85.9179 47.09948 84.567101 51.877617 76.9991 53.023838 C 75.81636 53.202972 74.780823 54.353981 73.314575 55.247482 C 72.433884 58.164867 71.705147 60.870857 71.450615 63.620735 C 71.125885 67.128998 71.18428 70.672722 71.072052 74.137985 C 71.066574 74.074814 71.193237 74.068626 71.059212 74.140327 C 70.695824 74.462753 70.699043 74.722656 70.922928 75.333664 C 70.805244 76.11805 70.699455 76.560509 70.30191 77.175797 C 70.100418 79.310486 70.190666 81.272354 70.376656 83.631943 C 70.399422 85.657776 70.326439 87.285896 69.871002 89.074409 C 68.993286 91.0466 68.041695 92.868019 68.079651 94.668579 C 68.271164 103.755417 68.720406 112.83683 68.906677 122.137138 C 68.098709 122.227844 67.463295 122.101555 66.842628 121.613297 C 64.12281 118.870255 61.427517 116.442108 58.644653 114.118866 C 54.243069 110.444229 49.454155 107.164726 45.445423 103.108894 C 41.871517 99.492996 39.132927 95.051483 36.017456 90.985779 C 36.009212 90.997231 36.023975 90.985397 36.020256 90.556526 C 35.804646 86.817162 36.982445 83.037445 32.947018 80.604187 C 32.929581 78.80352 32.906498 77.418488 32.911514 75.651932 C 32.347607 73.797203 31.755608 72.324005 31.130735 70.645828 C 31.097862 70.440857 31.053917 70.025932 31.053627 69.77182 C 31.050751 69.348312 31.048164 69.178925 31.254055 68.693939 C 31.622944 63.673454 31.932768 58.965542 31.837568 54.265831 C 31.814091 53.106846 30.472713 51.974552 29.711481 50.509537 C 29.725815 49.762981 29.765854 49.33688 30.179504 48.875404 C 35.831047 47.128048 33.08852 43.198696 33.200573 39.779205 C 33.942482 38.713501 34.480305 37.870697 35.363079 36.94751 C 37.449368 33.898705 39.190708 30.93029 40.943024 27.633636 C 40.950985 26.867023 40.947968 26.428652 41.268028 25.851521 C 42.72242 25.051479 44.317978 24.670612 44.913029 23.685432 C 50.696918 14.109517 59.96138 9.040006 69.470955 4.194084 C 70.835518 3.498728 71.832764 2.082574 73 1 M 63.087112 41.703945 C 63.087112 41.703945 63.56424 41.785179 63.56424 41.785179 C 63.56424 41.785179 64.0373 41.682968 64.735718 41.728775 C 65.201942 41.705612 65.668167 41.682446 66.632072 42.157074 C 70.594719 43.324833 73.70948 42.30183 74.728516 38.107292 C 75.892311 33.316864 72.887245 31.644152 68.694038 31.060867 C 67.48568 30.89278 66.419182 29.859587 65.204346 29.551592 C 62.543098 28.876894 58.326702 27.086061 57.419682 28.113014 C 54.786564 31.094294 53.330456 35.184399 51.826172 39.002434 C 51.645802 39.460236 53.885574 41.472401 55.230618 41.783913 C 57.064465 42.20863 59.116455 41.691444 61.608963 41.613209 C 61.961414 41.56319 62.313866 41.513172 63.087112 41.703945 z",
    strokeLinecap: "round"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -56.93, 1)"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 60.990002, 1)"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -41.380001, -72.980003)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 3.01, 80.559998)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(92,177,158)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-93, -170.56)",
    d: "M 103 181 C 96.645599 181 90.291206 181 83.444397 180.532684 C 82.926613 174.681747 82.90123 169.298141 83.199158 164.113678 C 84.628105 167.655609 85.733749 170.998398 86.731087 174.013733 C 89.447472 174.013733 92.728432 174.013733 96.007797 174.000153 C 96.006195 173.986588 95.977058 173.990692 96.077881 174.205429 C 96.39225 174.660721 96.647018 174.843994 97.190552 174.655518 C 97.641663 171.018173 97.845238 167.695267 98.254257 164.093063 C 99.362183 162.58252 100.264671 161.351288 101.452469 160.117874 C 102.116684 160.139771 102.495598 160.163849 102.88884 160.644379 C 102.935448 167.733871 102.967728 174.366943 103 181 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 22.059999, 81.449997)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(89,184,162)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-112.05, -171.45)",
    d: "M 118 181 C 114.307091 181 110.614182 181 106.467361 180.531677 C 106.002251 174.009003 105.991051 167.954681 106.42717 161.90358 C 109.93367 162.212952 112.992836 162.519104 116.041199 163.300339 C 116.68692 169.516953 117.34346 175.258469 118 181 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -25.99, 80.370003)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(35,118,100)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-64.01, -170.37)",
    d: "M 68 181 C 67.555557 181 67.111107 181 66.3927 180.534485 C 66.129601 175.253326 66.377853 170.418839 65.997971 165.634216 C 65.892265 164.302795 63.926998 163.119034 62.814838 161.867523 C 61.849125 163.098312 60.124908 164.285385 60.05101 165.567581 C 59.755466 170.695663 59.972561 175.853302 60 181 C 58.933212 181 57.866425 181 56.391815 180.53183 C 55.952503 174.065872 55.921009 168.068069 56.10614 161.857849 C 56.54459 161.09227 56.766418 160.539124 57.330315 159.756104 C 62.457237 159.682495 67.242081 159.83876 72.022812 160.353348 C 72.004044 161.428192 71.989395 162.14473 71.640793 162.883835 C 70.861198 162.933258 70.415558 162.960098 69.618896 163.153412 C 68.848434 164.812897 68.123878 166.294418 68.067162 167.801102 C 67.901749 172.195358 68.003181 176.59964 68 181 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -34.209999, -76.629997)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(227,171,94)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-55.79, -13.37)",
    d: "M 46.02541 17.132475 C 50.848244 10.29458 57.466602 5.606454 64.820587 1.292141 C 67.37056 1 69.741112 1 72.555832 1 C 71.832764 2.082574 70.835518 3.498728 69.470955 4.194084 C 59.96138 9.040006 50.696918 14.109517 44.913029 23.685432 C 44.317978 24.670612 42.72242 25.051479 41.026222 25.732334 C 39.980457 25.502903 39.499588 25.253897 39.018719 25.004892 C 40.07925 23.376478 41.139782 21.748062 42.847153 19.979837 C 44.337799 18.93751 45.181602 18.034992 46.02541 17.132475 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -26.940001, 81.440002)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(92,183,162)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-63.06, -171.43)",
    d: "M 60.428459 181 C 59.972561 175.853302 59.755466 170.695663 60.05101 165.567581 C 60.124908 164.285385 61.849125 163.098312 62.814838 161.867523 C 63.926998 163.119034 65.892265 164.302795 65.997971 165.634216 C 66.377853 170.418839 66.129601 175.253326 66.059372 180.534485 C 64.285645 181 62.571281 181 60.428459 181 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -10.83, 80.010002)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(37,120,101)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-79.17, -170.01)",
    d: "M 82.875847 163.914536 C 82.90123 169.298141 82.926613 174.681747 82.975998 180.532684 C 82.25 181 81.5 181 80.385956 180.531708 C 80.021904 174.310913 80.021904 168.558411 80.021904 162.805908 C 79.347939 162.820038 78.673965 162.834152 78 162.848282 C 78 168.898849 78 174.949432 78 181 C 77.555557 181 77.111107 181 76.333855 180.531616 C 75.668732 173.375778 75.336411 166.688324 75.356316 159.844574 C 80.103798 157.694794 81.982391 159.969315 82.875847 163.914536 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 34.380001, 81.470001)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(93,186,163)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-124.37, -171.48)",
    d: "M 127 181 C 125.285622 181 123.571251 181 121.470726 180.576523 C 121.382088 174.097229 121.679588 168.041428 122.370743 161.952911 C 124.295135 162.184616 125.825874 162.449036 127.291229 163.195435 C 127.150566 169.451599 127.075287 175.2258 127 181 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 39.599998, 80.75)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(80,155,138)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-129.6, -170.74)",
    d: "M 127.416664 181 C 127.075287 175.2258 127.150566 169.451599 127.558578 163.134094 C 128.907516 161.755707 129.923721 160.920624 131.033203 160.488541 C 131.417648 167.594345 131.708832 174.29718 132 181 C 130.611115 181 129.222214 181 127.416664 181 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -43.029999, 79.110001)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(107,120,119)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-46.97, -169.12)",
    d: "M 41.454109 181 C 41 179.857788 41 178.715591 41 177.078156 C 43.980934 177.078156 46.706757 177.078156 49.756802 177.078156 C 49.756802 171.218872 49.756802 165.846191 49.298473 160.218933 C 48.840145 159.964355 48.684345 159.850754 48.831192 159.576813 C 49.668358 158.536255 50.358673 157.769623 51.246632 157.232101 C 51.947128 158.332642 52.449978 159.204056 52.938553 160.374603 C 52.924046 161.072128 52.92382 161.470551 52.682869 162.216492 C 51.961426 168.709351 51.480709 174.854675 51 181 C 47.969406 181 44.938812 181 41.454109 181 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -16.02, 80.440002)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(39,132,109)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-73.99, -170.44)",
    d: "M 75.004089 160.00087 C 75.336411 166.688324 75.668732 173.375778 76.000519 180.531616 C 74.933327 181 73.866661 181 72.400421 180.532028 C 71.992165 174.329788 71.983459 168.59552 71.974754 162.861252 C 71.989395 162.14473 72.004044 161.428192 72.262886 160.448685 C 73.339424 160.124084 74.171761 160.062469 75.004089 160.00087 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -36.290001, 81.510002)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(95,180,161)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-53.7, -171.52)",
    d: "M 51.416664 181 C 51.480709 174.854675 51.961426 168.709351 53.056175 162.244705 C 54.409985 161.973679 55.14975 162.021973 55.889511 162.070282 C 55.921009 168.068069 55.952503 174.065872 55.991997 180.53183 C 54.611111 181 53.222221 181 51.416664 181 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 43.169998, 78.510002)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(96,134,129)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-133.17, -168.51)",
    d: "M 132.375 181 C 131.708832 174.29718 131.417648 167.594345 131.331924 160.382294 C 131.983688 159.227249 132.430008 158.581421 132.923309 157.61554 C 132.985886 156.864685 133.001495 156.433868 133.266113 156.019409 C 133.515121 156.035767 134.013397 156.069504 134.16188 156.377197 C 134.545242 157.785202 134.780136 158.885529 135.01799 160.455261 C 135.013977 167.61647 135.006989 174.308228 135 181 C 134.25 181 133.5 181 132.375 181 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 50.049999, 80.809998)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(134,150,149)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-140.04, -170.8)",
    d: "M 135.454102 181 C 135.006989 174.308228 135.013977 167.61647 135.225922 160.610306 C 135.647263 160.565338 135.863617 160.834778 136.079987 161.104202 C 136.544937 166.162186 137.009888 171.220154 137.485504 176.39415 C 139.064102 179.180969 145.090134 173.529037 144.998718 180.568115 C 141.969406 181 138.938812 181 135.454102 181 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 28.18, 81.68)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(91,170,152)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-118.18, -171.67)",
    d: "M 118.333328 181 C 117.34346 175.258469 116.68692 169.516953 116.321487 163.204727 C 117.756966 162.413574 118.901352 162.19313 120.034256 162.442535 C 120.015182 168.941589 120.007591 174.970795 120 181 C 119.555557 181 119.111107 181 118.333328 181 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 14.52, 80.589996)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(65,144,128)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-104.52, -170.58)",
    d: "M 105.979843 161.900345 C 105.991051 167.954681 106.002251 174.009003 106.006729 180.531677 C 105.25 181 104.5 181 103.375 181 C 102.967728 174.366943 102.935448 167.733871 103.243469 160.598541 C 104.059013 160.089539 104.534264 160.08284 105.124817 160.307587 C 105.486687 160.992798 105.733269 161.446579 105.979843 161.900345 z",
    strokeLinecap: "round"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 40.939999, -85.730003)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -10.99, 81.910004)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(89,170,151)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-79.01, -171.9)",
    d: "M 78.333328 181 C 78 174.949432 78 168.898849 78 162.848282 C 78.673965 162.834152 79.347939 162.820038 80.021904 162.805908 C 80.021904 168.558411 80.021904 174.310913 80.010956 180.531708 C 79.555557 181 79.111107 181 78.333328 181 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -19.01, 81.879997)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(53,138,118)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-70.99, -171.88)",
    d: "M 71.640793 162.883835 C 71.983459 168.59552 71.992165 174.329788 72.000427 180.532028 C 71.555557 181 71.111107 181 70.33342 180.532059 C 69.990089 174.371719 69.980003 168.679321 69.969925 162.986938 C 70.415558 162.960098 70.861198 162.933258 71.640793 162.883835 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -21, 82.07)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(45,124,106)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-68.99, -172.08)",
    d: "M 69.618896 163.153397 C 69.980003 168.679321 69.990089 174.371719 70.000092 180.532059 C 69.555557 181 69.111107 181 68.333328 181 C 68.003181 176.59964 67.901749 172.195358 68.067162 167.801102 C 68.123878 166.294418 68.848434 164.812897 69.618896 163.153397 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 31.030001, 81.5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(66,148,129)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-121.03, -171.49)",
    d: "M 120.25 181 C 120.007591 174.970795 120.015182 168.941589 120.355728 162.450882 C 121.118156 161.988129 121.547623 161.986862 121.977097 161.985611 C 121.679588 168.041428 121.382088 174.097229 121.04229 180.576523 C 121 181 120.5 181 120.25 181 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 32.5, -86.959999)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(206,175,131)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-122.5, -3.04)",
    d: "M 124.583336 1 C 125.03714 1.404402 125.07428 1.808804 124.818268 2.643646 C 124.020935 3.742285 123.516754 4.410486 123.012573 5.078684 C 122.018829 3.972784 121.025085 2.866886 120.015671 1.380494 C 121.388893 1 122.777779 1 124.583336 1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 19.790001, 31.209999)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(90,179,159)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-109.79, -121.2)",
    d: "M 113.954247 111.09919 C 113.994926 112.123573 114.035614 113.147957 113.845543 114.425232 C 112.799271 115.074219 111.815712 115.317879 111.250435 115.941002 C 111.022369 116.192398 111.709511 117.27404 111.979065 118.316315 C 111.973999 119.105637 111.970016 119.556496 111.736115 120.280411 C 110.906281 121.540154 110.20713 122.480759 109.723808 123.521568 C 107.753906 127.763641 108.975975 134.438202 112.210175 136.006729 C 112.642281 136.017349 112.815117 136.021561 112.99028 136.350952 C 112.992966 137.109695 112.993332 137.543274 112.812149 138.11496 C 112.401764 138.454559 112.202171 138.681732 112.027252 139.336853 C 112.668587 142.091141 113.314499 144.443207 113.583534 146.869232 C 110.85878 146.904251 108.51091 146.86528 106.136314 146.420746 C 105.930389 144.667068 105.75119 143.31897 105.596909 141.648956 C 105.591316 140.898132 105.560806 140.469223 105.634613 139.611816 C 105.730324 137.441223 105.72171 135.699158 105.780853 133.633163 C 105.900116 132.871017 105.951622 132.4328 106.027168 131.645416 C 106.068024 130.601547 106.084839 129.906845 106.111008 128.794037 C 106.401649 125.578598 106.68293 122.781273 107.191261 119.667122 C 108.605171 113.10614 110.044098 106.842346 105.972137 100.605209 C 105.973473 99.134308 105.992073 98.064674 106.296677 96.764328 C 106.922531 96.18119 107.262383 95.828758 107.670418 95.525635 C 107.738602 95.574944 107.917221 95.581566 108.047523 95.893051 C 108.794685 96.84832 109.411537 97.492104 110.088837 98.504379 C 110.412384 100.585075 110.675476 102.297279 110.80658 104.120529 C 110.791611 104.48877 110.90863 104.745972 111.313583 105.093277 C 112.038536 105.800362 112.475555 106.417351 112.72377 107.291885 C 113.008057 108.732681 113.481155 109.915939 113.954247 111.09919 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -26.6, -54.880001)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(244,214,159)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-63.4, -35.12)",
    d: "M 61.074913 41.578102 C 59.116455 41.691444 57.064465 42.20863 55.230618 41.783913 C 53.885574 41.472401 51.645802 39.460236 51.826172 39.002434 C 53.330456 35.184399 54.786564 31.094294 57.419682 28.113014 C 58.326702 27.086061 62.543098 28.876894 65.204346 29.551592 C 66.419182 29.859587 67.48568 30.89278 68.694038 31.060867 C 72.887245 31.644152 75.892311 33.316864 74.728516 38.107292 C 73.70948 42.30183 70.594719 43.324833 66.669891 41.730034 C 69.152824 40.892204 71.603302 40.048573 70.715393 37.057961 C 70.389801 35.961296 67.99437 35.494041 66.561981 34.705437 C 65.724678 34.244457 64.981377 33.47702 64.096161 33.266666 C 62.166451 32.808105 60.173023 32.617657 58.205635 32.31765 C 58.150703 34.621834 57.79974 36.97683 58.182354 39.20591 C 58.341793 40.134773 60.063553 40.795467 61.074913 41.578102 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9.6, -35.330002)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(64,97,70)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-80.4, -54.67)",
    d: "M 73.677216 55.055588 C 74.780823 54.353981 75.81636 53.202972 76.9991 53.023838 C 84.567101 51.877617 85.9179 47.09948 84.970093 40.130089 C 85.573318 39.176273 85.790573 38.698162 86.007835 38.220051 C 86.234039 37.664257 86.460243 37.108463 87.082077 36.256542 C 87.661522 35.944477 87.845345 35.928539 88.018311 36.273338 C 87.700394 37.774536 87.393333 38.915005 87.050354 40.480049 C 87.056274 42.877132 87.098122 44.849636 87.103828 47.220345 C 86.682915 49.429893 86.298149 51.241234 85.532623 53.026897 C 83.438019 53.267162 81.724159 53.533108 81.365463 53.588768 C 80.231476 56.44603 79.694786 58.286503 78.788559 59.922249 C 78.103333 61.159077 76.003609 62.375149 76.207367 63.172916 C 76.563469 64.567162 78.217827 65.622597 79.306786 66.839142 C 80.190735 67.82666 81.043343 68.842232 81.579399 69.885811 C 80.806633 69.971024 80.364311 70.015778 79.557281 70.053589 C 77.041817 71.285645 74.891075 72.524635 72.790421 73.311646 C 73.119415 66.924973 73.398315 60.99028 73.677216 55.055588 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -38.709999, 16.610001)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(225,169,96)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-51.29, -106.62)",
    d: "M 65.200562 122.256332 C 64.052231 121.834007 62.9039 121.411674 61.115013 120.689438 C 56.961781 117.92691 53.449097 115.464302 49.948868 112.704704 C 47.03603 109.487183 44.110733 106.56665 41.06881 103.321228 C 39.305515 100.648415 37.658852 98.300491 36.009422 95.538239 C 36.013008 93.740715 36.019356 92.357513 36.025703 90.974319 C 39.132927 95.051483 41.871517 99.492996 45.445423 103.108894 C 49.454155 107.164726 54.243069 110.444229 58.644653 114.118866 C 61.427517 116.442108 64.12281 118.870255 66.572433 121.65818 C 65.925186 122.128792 65.562874 122.192566 65.200562 122.256332 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 47.939999, -17.77)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(230,169,92)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-137.94, -72.23)",
    d: "M 145.159927 65.718323 C 145.159927 65.718323 145.024307 65.49353 144.920563 64.989159 C 142.597061 63.854053 140.409836 62.89476 138.14975 62.670795 C 134.887527 62.347519 133.614166 63.908371 135.053131 67.422287 C 133.646393 69.863907 132.361328 71.984657 130.707397 74.162643 C 126.8778 77.571136 127.005707 79.635468 131.009033 85.041023 C 126.545746 87.245697 125.301781 83.481918 125.333954 80.925758 C 125.377419 77.472702 126.826324 73.961227 128.083832 70.630203 C 128.759369 68.840759 130.456177 67.466118 131.416443 65.750023 C 136.625504 56.440849 144.773682 56.326813 150.546234 65.981995 C 149.996246 66.651176 149.435669 66.875832 148.574783 67.044891 C 147.878067 66.892853 147.481644 66.79641 147.05542 66.543442 C 146.741791 66.149841 146.457993 65.912773 145.920654 65.686996 C 145.498047 65.704979 145.328979 65.711647 145.159927 65.718323 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 41.650002, 20.68)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(230,169,92)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-131.65, -110.68)",
    d: "M 114.147293 120.994362 C 116.348038 120.425957 118.531754 119.777817 120.752579 119.303398 C 128.931808 117.55616 134.563675 112.095551 139.877884 106.204025 C 141.042526 104.912842 141.781143 103.241966 142.918884 101.9207 C 144.138275 100.504639 145.597183 99.294823 147.559067 98.158974 C 148.527512 98.550743 148.888458 98.778542 149.205017 99.3423 C 148.8004 100.480751 148.44017 101.283234 147.744812 102.122902 C 146.196777 103.760933 144.983826 105.361786 143.753281 107.281967 C 143.703232 108.025787 143.670792 108.450272 143.330383 108.941689 C 142.017059 110.037178 141.011734 111.065742 139.664795 112.103973 C 138.228607 113.0811 137.134033 114.048569 135.744186 115.164307 C 133.605606 116.796425 131.762314 118.280281 129.544952 119.810249 C 126.427177 120.98085 123.683472 122.105324 120.544495 123.203964 C 118.139565 122.802628 116.129898 122.427124 114.094788 121.786484 C 114.095322 121.345688 114.121307 121.170029 114.147293 120.994362 z",
    strokeLinecap: "round"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -61.509998, -43)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 50.310001, -10.03)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(207,174,136)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-140.31, -79.97)",
    d: "M 131.476196 85.028862 C 127.005707 79.635468 126.8778 77.571136 130.621796 74.525269 C 129.790161 80.00206 129.795822 80.006912 136.842728 79.934822 C 141.587067 80.29715 146.331421 80.659477 151.678711 81.367523 C 152.508545 82.487656 152.735443 83.262062 152.631241 84.096764 C 151.500504 84.573494 150.700867 84.989937 149.901215 85.40638 C 143.915253 85.276489 137.929306 85.146591 131.476196 85.028862 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 9.64, -30.639999)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(95,176,160)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-99.64, -59.36)",
    d: "M 102.173958 50.743568 C 103.268829 51.434219 104.363701 52.12487 105.889267 53.243469 C 106.616096 54.230804 106.912231 54.790188 107.127197 55.671429 C 105.672546 57.662785 104.299065 59.332275 102.59996 61.143166 C 101.843079 62.869629 101.411804 64.454697 100.647064 66.02504 C 99.872421 65.955124 99.431259 65.89994 98.916916 65.61235 C 98.232025 65.541748 97.620316 65.70356 96.708618 65.971428 C 95.352737 66.774376 94.296829 67.471268 93.000076 67.980347 C 92.491356 67.487961 92.223465 67.183388 92.151276 66.649094 C 93.220207 65.606056 94.093445 64.79274 95.05201 63.948387 C 95.137329 63.917347 95.142395 63.717186 95.142395 63.717186 C 95.142395 63.717186 95.026443 64.03746 94.680191 63.925362 C 93.921867 62.528793 93.509789 61.244324 93.120834 59.709129 C 93.125946 59.291519 93.107925 59.124634 93.085846 58.733154 C 93.081802 58.508564 93.044594 58.060207 93.046562 58.053001 C 93.048531 58.045792 93.060707 58.041569 93.38475 58.085037 C 98.899033 58.381836 100.186432 54.161438 102.173958 50.743568 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 17.5, -26.469999)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(43,133,110)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-107.5, -63.52)",
    d: "M 102.925575 61.001766 C 104.299065 59.332275 105.672546 57.662785 107.367172 55.55418 C 108.067032 54.765877 108.445755 54.416679 108.824478 54.067486 C 109.838524 54.786194 110.85257 55.504898 111.996414 56.90218 C 112.079018 60.84589 112.125687 64.116127 111.948944 67.374229 C 111.845123 69.287849 111.385963 71.182205 110.746155 72.978836 C 107.912315 68.91555 105.418945 64.958656 102.925575 61.001766 M 105.507591 62.505169 C 105.507591 62.505169 105.460487 62.525955 105.507591 62.505169 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -25.540001, -53.009998)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(243,231,215)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-64.45, -36.99)",
    d: "M 61.341938 41.595657 C 60.063553 40.795467 58.341793 40.134773 58.182354 39.20591 C 57.79974 36.97683 58.150703 34.621834 58.205635 32.31765 C 60.173023 32.617657 62.166451 32.808105 64.096161 33.266666 C 64.981377 33.47702 65.724678 34.244457 66.561981 34.705437 C 67.99437 35.494041 70.389801 35.961296 70.715393 37.057961 C 71.603302 40.048573 69.152824 40.892204 66.421051 41.48114 C 65.668167 41.682446 65.201942 41.705612 64.179878 41.581192 C 63.301006 41.318367 62.981766 41.328217 62.666317 41.463154 C 62.313866 41.513172 61.961414 41.56319 61.341938 41.595657 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -18.33, 8.07)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(84,100,55)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-71.67, -98.07)",
    d: "M 70.253456 88.914017 C 70.326439 87.285896 70.399422 85.657776 70.527115 83.266884 C 70.58577 80.670403 70.589714 78.836685 70.593658 77.002975 C 70.699455 76.560509 70.805244 76.11805 71.044922 75.118896 C 71.178802 74.56221 71.193237 74.068626 71.193237 74.068626 C 71.193237 74.068626 71.066574 74.074814 71.318756 74.119019 C 71.570946 74.163223 72.05027 74.037384 72.202576 74.222946 C 72.571335 74.64994 72.822571 74.847038 73.088303 75.390396 C 72.970016 76.814766 72.872032 77.848534 72.576691 79.24054 C 72.369987 82.445068 72.360626 85.291344 72.311401 88.420418 C 72.283859 89.084351 72.296188 89.465492 72.239281 90.224182 C 72.194305 91.111443 72.218552 91.621162 72.206024 92.573746 C 72.194946 95.977486 72.220657 98.938354 72.183594 102.366501 C 72.190422 107.211693 72.260025 111.5896 72.299179 116.24823 C 72.490715 117.034065 72.712708 117.539185 72.932152 118.43959 C 72.955811 119.888611 72.982002 120.942352 72.750168 122.016525 C 72.321342 122.061546 72.150536 122.086128 71.739761 122.041473 C 71.499779 121.972221 71.017151 121.843353 71.030289 121.422279 C 70.780106 110.305473 70.516777 99.609749 70.253456 88.914017 z",
    strokeLinecap: "round"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 67.849998, -46.189999)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 7.76, -38.200001)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(68,127,118)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-97.76, -51.81)",
    d: "M 102.168991 50.439285 C 100.186432 54.161438 98.899033 58.381836 93.354843 57.682423 C 93.454231 53.434368 93.907562 49.632393 94.683395 45.851646 C 96.743347 46.29937 98.480797 46.725853 100.218246 47.15234 C 100.866837 48.146564 101.515427 49.140785 102.168991 50.439285 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 22.33, 1.93)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(123,125,79)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-112.33, -91.92)",
    d: "M 112.912575 107.034332 C 112.475555 106.417351 112.038536 105.800362 111.296494 104.844566 C 110.99147 104.505753 110.938576 104.009491 110.938576 104.009491 C 110.675476 102.297279 110.412384 100.585075 110.352432 98.163498 C 110.646873 91.974983 110.738159 86.495842 110.989243 80.680679 C 111.456352 78.907097 111.763657 77.469521 112.382874 76.1371 C 113.130188 77.187843 113.565582 78.133438 114.000977 79.079033 C 114.219101 88.59745 114.437225 98.115875 114.217072 107.709953 C 113.490051 107.535187 113.201309 107.28476 112.912575 107.034332 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 64.860001, -29.15)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(218,170,110)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-154.85, -60.85)",
    d: "M 158.226715 51.048649 C 159.04097 52.088333 159.672913 53.464752 160.566467 54.940323 C 160.882462 58.699238 160.936813 62.359005 160.58551 66.568741 C 156.408646 68.94194 152.631989 74.142937 148.875092 67.100487 C 149.435669 66.875832 149.996246 66.651176 150.78479 66.225586 C 152.076447 66.035927 153.140121 66.047195 154.815231 66.211143 C 155.974213 65.579536 156.521774 64.795265 157.069321 64.010994 C 157.078903 63.575336 157.088486 63.139675 157.394257 62.250271 C 157.495087 60.517181 157.299713 59.237839 157.104355 57.958496 C 157.417709 55.767456 157.731049 53.57642 158.226715 51.048649 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 8.25, -47.66)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(91,169,148)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-98.25, -42.34)",
    d: "M 100.513916 47.008865 C 98.480797 46.725853 96.743347 46.29937 94.499115 45.650238 C 93.679077 45.251762 93.365814 45.075928 93.038559 44.529053 C 94.685226 42.03751 96.345886 39.917007 98.277473 37.791451 C 98.724838 37.747616 98.901276 37.708836 99.077713 37.670055 C 104.352264 39.235176 104.891937 42.100586 100.513916 47.008865 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -60.720001, -30.120001)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(225,169,96)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-29.28, -59.88)",
    d: "M 26.703291 60.945793 C 26.798929 58.924725 26.894567 56.903652 27.382875 54.414238 C 28.449093 52.936508 29.122639 51.927116 29.796185 50.917728 C 29.796185 50.917728 29.756598 50.882168 29.746891 50.856079 C 30.472713 51.974552 31.814091 53.106846 31.837568 54.265831 C 31.932768 58.965542 31.622944 63.673454 30.854279 68.689163 C 29.187277 68.994362 28.128523 68.988739 27.033989 68.539772 C 26.899902 65.712891 26.801596 63.329342 26.703291 60.945793 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -21.49, 39.41)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(134,134,124)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-68.5, -129.41)",
    d: "M 71.017151 121.843353 C 71.017151 121.843353 71.499779 121.972221 71.757339 122.403625 C 71.992676 123.564667 71.970444 124.294304 71.581863 125.115707 C 66.879555 128.412491 69.933235 133.0578 68.557144 136.929825 C 67.174767 136.957611 66.169197 136.968735 65.163635 136.979858 C 65.118668 132.357315 65.0737 127.734764 65.114647 122.684273 C 65.562874 122.192566 65.925186 122.128792 66.557693 122.020142 C 67.463295 122.101555 68.098709 122.227844 69.228668 122.164032 C 70.154533 121.930405 70.585838 121.886879 71.017151 121.843353 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 22.870001, -22.049999)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(111,134,96)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-112.86, -67.94)",
    d: "M 114.173309 78.700569 C 113.565582 78.133438 113.130188 77.187843 112.3069 75.832802 C 111.641541 74.643974 111.36409 73.864594 111.086632 73.08522 C 111.385963 71.182205 111.845123 69.287849 111.948944 67.374229 C 112.125687 64.116127 112.079018 60.84589 112.150696 57.185341 C 113.023018 58.022282 114.569756 59.237926 114.599693 60.489834 C 114.741669 66.428505 114.469994 72.377068 114.173309 78.700569 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -20.440001, 15.51)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(236,169,81)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-69.55, -105.51)",
    d: "M 71.030289 121.422287 C 70.585838 121.886879 70.154533 121.930405 69.401222 121.947037 C 68.720406 112.83683 68.271164 103.755417 68.079651 94.668579 C 68.041695 92.868019 68.993286 91.0466 69.871002 89.074409 C 70.516777 99.609749 70.780106 110.305473 71.030289 121.422287 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -57.07, -5.03)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(220,172,110)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-32.93, -84.97)",
    d: "M 36.017456 90.985779 C 36.019356 92.357513 36.013008 93.740715 35.700386 95.542816 C 34.982441 95.947113 34.570763 95.932495 34.159088 95.917877 C 33.658596 93.690788 33.158108 91.463707 32.330719 88.651672 C 31.254929 85.369102 30.17338 82.708534 29.867338 79.961563 C 29.641642 77.935753 30.428297 75.797165 30.875303 74.023773 C 31.618956 74.903641 32.251186 75.468552 32.883415 76.033463 C 32.906498 77.418488 32.929581 78.80352 32.787632 80.836105 C 33.75639 84.650909 34.890182 87.818153 36.023975 90.985397 C 36.023975 90.985397 36.009212 90.997231 36.017456 90.985779 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4.45, -57.77)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(64,110,100)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-94.44, -32.24)",
    d: "M 99.23941 37.468369 C 98.901276 37.708836 98.724838 37.747616 98.270752 37.456944 C 96.413193 32.593319 91.85598 34.617611 88.777107 32.766396 C 90.4254 30.621227 92.239914 28.728876 94.054428 26.836525 C 94.054428 26.836523 94.127777 26.703255 94.176476 27.095455 C 95.90731 29.256765 97.589447 31.025875 99.271584 32.794983 C 99.271584 32.794983 99.222359 32.889427 99.242325 33.099861 C 99.418823 33.612625 99.654518 33.828468 99.969391 33.957829 C 100.035011 34.119823 100.100624 34.281818 100.105682 34.959557 C 100.065933 35.822186 100.086731 36.169067 100.107529 36.515953 C 99.872055 36.766197 99.636574 37.016441 99.23941 37.468369 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 50.41, -71.050003)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(232,169,91)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-140.41, -18.95)",
    d: "M 145.021973 25.976097 C 141.385818 21.557516 137.749664 17.138935 134.084564 12.33475 C 134.055603 11.949147 134.152771 11.857864 134.461685 11.959292 C 136.558075 13.334864 138.345566 14.609007 140.263123 16.066095 C 140.575043 16.488125 140.778763 16.706814 141.149933 17.22617 C 142.589554 18.327793 143.883591 19.108355 145.433731 20.071369 C 146.149445 21.1674 146.60907 22.080978 146.749207 23.091286 C 145.960464 24.117374 145.491211 25.046736 145.021973 25.976097 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 61.52, 0.12)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(230,169,92)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-151.52, -90.13)",
    d: "M 150.008484 85.727951 C 150.700867 84.989937 151.500504 84.573494 152.793991 84.362625 C 156.791473 87.551895 154.845886 90.22538 152.578125 93.012138 C 150.87558 94.050697 149.408752 94.971077 147.94194 95.891449 C 148.66655 92.610809 149.391159 89.33017 150.008484 85.727951 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 65.220001, -46.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(233,169,89)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-155.22, -43.77)",
    d: "M 154.421814 38.005692 C 155.928864 41.675713 157.093842 45.393219 158.235687 49.526604 C 156.179901 46.789761 154.072662 43.679272 152.227814 40.420258 C 152.039368 40.087349 153.424698 38.86356 154.421814 38.005692 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 37.52, -83.519997)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(227,170,97)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-127.53, -6.48)",
    d: "M 123.183533 5.357318 C 123.516754 4.410486 124.020935 3.742285 124.834457 2.947828 C 125.622932 3.093366 126.102066 3.365161 126.790131 4.02472 C 127.328812 4.625492 127.658562 4.8385 127.988312 5.051507 C 129.172028 5.551472 130.355743 6.051437 131.734558 7.052679 C 131.929672 7.553955 131.907089 8.026215 131.686798 8.232859 C 130.63855 8.964423 129.810577 9.489343 128.982605 10.014264 C 127.106567 8.554827 125.230537 7.095388 123.183533 5.357318 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -52.09, -57.759998)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(227,171,94)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-37.91, -32.24)",
    d: "M 34.878799 32.790741 C 35.077232 31.686741 35.275665 30.582743 36.048405 29.16806 C 38.059155 28.55888 39.495602 28.260378 40.932045 27.961876 C 39.190708 30.93029 37.449368 33.898705 35.357498 36.52549 C 34.964241 35.052822 34.92152 33.92178 34.878799 32.790741 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -17.73, -25.280001)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(236,169,81)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-72.27, -64.71)",
    d: "M 72.05027 74.037384 C 72.05027 74.037384 71.570946 74.163223 71.324234 74.18219 C 71.18428 70.672722 71.125885 67.128998 71.450615 63.620735 C 71.705147 60.870857 72.433884 58.164867 73.314575 55.247482 C 73.398315 60.99028 73.119415 66.924973 72.803383 73.331848 C 72.766251 73.804031 72.814896 73.816109 72.594872 73.771667 C 72.374847 73.727219 72.05027 74.037384 72.05027 74.037384 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 57.939999, -63.84)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(220,172,106)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-147.94, -26.16)",
    d: "M 145.170441 26.273907 C 145.491211 25.046736 145.960464 24.117374 147.031036 23.260199 C 148.778183 25.213831 149.924011 27.095278 150.703125 28.985125 C 149.845917 29.013807 149.355438 29.034088 148.864975 29.054367 C 147.682953 28.226818 146.500916 27.399267 145.170441 26.273907 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0.41, -58.759998)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(101,102,64)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-90.41, -31.24)",
    d: "M 93.822884 26.548317 C 92.239914 28.728876 90.4254 30.621227 88.727417 33.06786 C 88.57235 34.385628 88.300758 35.149117 88.029167 35.912605 C 87.845345 35.928539 87.661522 35.944477 87.201736 35.981323 C 86.391998 28.410381 87.939743 26.148266 93.822884 26.548317 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -56.650002, -53.540001)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(220,172,110)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-33.36, -36.46)",
    d: "M 34.547951 32.836769 C 34.92152 33.92178 34.964241 35.052822 35.012543 36.605881 C 34.480305 37.870697 33.942482 38.713501 32.876976 39.79578 C 32.133751 40.050083 31.918219 40.064915 31.702686 40.079742 C 31.82159 38.019291 31.940496 35.958839 32.068825 33.528122 C 32.078251 33.157852 32.468441 33.01041 32.675255 32.9832 C 33.327076 32.931591 33.772087 32.907196 34.547951 32.836769 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -55.599998, -4.1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(225,169,96)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-34.4, -85.9)",
    d: "M 36.020256 90.556526 C 34.890182 87.818153 33.75639 84.650909 32.781986 81.251755 C 36.982445 83.037445 35.804646 86.817162 36.020256 90.556526 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -58.209999, -45.549999)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(225,169,96)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-31.78, -44.45)",
    d: "M 31.700962 40.337471 C 31.918219 40.064915 32.133751 40.050083 32.672882 40.018684 C 33.08852 43.198696 35.831047 47.128048 30.179504 48.875404 C 29.780975 47.85865 29.756062 46.806526 30.137341 45.262463 C 30.957344 43.721123 31.371155 42.671722 31.784966 41.622322 C 31.75639 41.279949 31.727816 40.937576 31.700962 40.337471 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 60.419998, 6.22)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(209,176,129)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-150.42, -96.22)",
    d: "M 147.910751 96.232956 C 149.408752 94.971077 150.87558 94.050697 152.630646 93.433105 C 152.958679 94.861572 152.998474 95.987259 153.038284 97.112938 C 153.038284 97.112938 153.032471 97.031967 152.756302 97.084122 C 151.403214 97.759636 150.326309 98.382988 149.249405 99.006332 C 148.888458 98.778542 148.527512 98.550743 147.908234 98.124283 C 147.72644 97.475235 147.802994 97.024857 147.910751 96.232956 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 60.900002, -59.02)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(218,170,110)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-150.89, -30.97)",
    d: "M 148.886612 29.442425 C 149.355438 29.034088 149.845917 29.013807 150.998291 28.995068 C 152.054367 29.028576 152.448547 29.060541 152.842728 29.092505 C 152.910431 30.107891 152.978134 31.123276 152.668839 32.545116 C 151.207291 32.949646 150.122757 32.94772 149.038208 32.945793 C 148.994888 31.907356 148.951569 30.868919 148.886612 29.442425 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 6.74, -60.209999)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(101,102,64)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-96.74, -29.79)",
    d: "M 99.231339 32.448921 C 97.589447 31.025875 95.90731 29.256765 94.245712 27.126942 C 95.90786 28.545103 97.549477 30.323978 99.231339 32.448921 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 41.669998, -79.800003)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(232,169,91)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-131.67, -10.2)",
    d: "M 129.186707 10.301063 C 129.810577 9.489343 130.63855 8.964423 131.980438 8.403308 C 133.04715 9.530697 133.59996 10.69428 134.152771 11.857864 C 134.152771 11.857864 134.055603 11.949147 134.006683 11.995439 C 132.435455 11.557108 130.913116 11.072486 129.186707 10.301063 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -51.400002, -62.970001)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(220,172,110)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-38.6, -27.03)",
    d: "M 40.943024 27.633636 C 39.495602 28.260378 38.059155 28.55888 36.251541 28.898243 C 36.739368 27.737764 37.598362 26.536421 38.738037 25.169987 C 39.499588 25.253897 39.980457 25.502903 40.703136 25.871094 C 40.947968 26.428652 40.950985 26.867023 40.943024 27.633636 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 22.58, 26.93)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(96,166,144)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-112.58, -116.93)",
    d: "M 111.980148 117.977844 C 111.709511 117.27404 111.022369 116.192398 111.250435 115.941002 C 111.815712 115.317879 112.799271 115.074219 113.815048 114.808899 C 114.020531 116.036575 114.025764 117.133484 113.758102 118.652176 C 113.485199 119.073959 113.156853 119.142372 113.096832 118.942078 C 112.684593 118.487137 112.332367 118.232491 111.980148 117.977844 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -19.639999, -9.97)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(236,169,81)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-70.36, -80.02)",
    d: "M 70.30191 77.175797 C 70.589714 78.836685 70.58577 80.670403 70.431366 82.869171 C 70.190666 81.272354 70.100418 79.310486 70.30191 77.175797 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -58.119999, -16.75)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(225,169,96)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-31.88, -73.25)",
    d: "M 32.911514 75.651932 C 32.251186 75.468552 31.618956 74.903641 30.899628 73.706192 C 30.824331 72.429916 30.836134 71.786179 30.926525 71.069183 C 31.005114 70.995918 31.163609 70.850807 31.163609 70.850807 C 31.755608 72.324005 32.347607 73.797203 32.911514 75.651932 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 23.559999, 33.509998)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(73,121,103)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-113.56, -123.51)",
    d: "M 113.156853 119.142372 C 113.156853 119.142372 113.485199 119.073959 113.650169 119.050385 C 113.877144 119.466064 113.93914 119.905312 114.074219 120.669464 C 114.121307 121.170029 114.095322 121.345688 114.049942 122.201553 C 114.009041 124.574677 113.987541 126.267578 113.735237 127.966858 C 113.504433 127.973236 113.043121 127.943329 113.023468 127.502106 C 113.054825 124.421379 113.105843 121.781876 113.156853 119.142372 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 61.119999, -56.009998)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(233,169,89)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-151.11, -33.99)",
    d: "M 149.176682 33.221748 C 150.122757 32.94772 151.207291 32.949646 152.6987 32.926765 C 153.105545 32.901962 153.050034 32.929466 153.040527 33.265053 C 153.021851 34.087479 153.01268 34.574314 153.003494 35.06115 C 151.774048 34.540001 150.544601 34.018852 149.176682 33.221748 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 67.25, -29.85)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(230,169,92)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-157.25, -60.15)",
    d: "M 157.07724 58.367123 C 157.299713 59.237839 157.495087 60.517181 157.398636 61.923473 C 157.087921 60.958866 157.069016 59.867306 157.07724 58.367123 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 23.41, 19.02)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(96,166,144)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-113.41, -109.02)",
    d: "M 112.72377 107.291885 C 113.201309 107.28476 113.490051 107.535187 113.956467 108.014412 C 114.128784 108.959816 114.123436 109.676414 114.036163 110.746109 C 113.481155 109.915939 113.008057 108.732681 112.72377 107.291885 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 66.010002, -24.82)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(230,169,92)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-156.01, -65.18)",
    d: "M 156.807312 64.151703 C 156.521774 64.795265 155.974213 65.579536 155.21431 66.209412 C 155.516403 65.467468 156.030838 64.879936 156.807312 64.151703 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -60.970001, -20.049999)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(220,172,110)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-29.03, -69.95)",
    d: "M 27.069771 68.983109 C 28.128523 68.988739 29.187277 68.994362 30.645805 69.004761 C 31.048164 69.178925 31.050751 69.348312 30.858082 69.891785 C 30.417933 70.450851 30.201338 70.66452 29.675444 70.919647 C 28.581818 70.282654 27.825794 69.632881 27.069771 68.983109 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 10.2, -54.16)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(101,102,64)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-100.19, -35.85)",
    d: "M 100.273079 36.470657 C 100.086731 36.169067 100.065933 35.822186 100.10202 35.221706 C 100.252151 35.453861 100.34539 35.939617 100.273079 36.470657 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 63.939999, -55.950001)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(218,170,110)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-153.94, -34.05)",
    d: "M 153.272217 35.075905 C 153.01268 34.574314 153.021851 34.087479 153.052246 33.23653 C 153.49762 32.910107 153.921768 32.947792 154.654678 33.064484 C 154.913864 33.606293 154.864288 34.069088 154.70874 34.868187 C 154.24881 35.166546 153.894882 35.128605 153.272217 35.075905 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 17.389999, -35.709999)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(95,175,159)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-107.39, -54.3)",
    d: "M 108.594147 53.853668 C 108.445755 54.416679 108.067032 54.765877 107.448341 55.232319 C 106.912231 54.790188 106.616096 54.230804 106.178986 53.392715 C 106.813278 53.289288 107.588539 53.464569 108.594147 53.853668 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.55, -50.919998)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(101,102,64)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-85.45, -39.08)",
    d: "M 85.766724 38.35265 C 85.790573 38.698162 85.573318 39.176273 85.139351 39.815739 C 85.123627 39.479809 85.324615 38.982529 85.766724 38.35265 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 9.56, -56.599998)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(101,102,64)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-99.55, -33.39)",
    d: "M 99.906403 33.719883 C 99.654518 33.828468 99.418823 33.612625 99.195572 33.074383 C 99.467552 32.941395 99.705742 33.155884 99.906403 33.719883 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -59.43, -19.43)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(225,169,96)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-30.57, -70.57)",
    d: "M 30.013048 70.906876 C 30.201338 70.66452 30.417933 70.450851 30.858374 70.145905 C 31.053917 70.025932 31.097862 70.440857 31.130735 70.645828 C 31.163609 70.850807 31.005114 70.995918 30.716686 71.016312 C 30.428259 71.036697 30.013048 70.906876 30.013048 70.906876 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -19.030001, -15.55)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(236,169,81)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-70.97, -74.46)",
    d: "M 71.059212 74.140327 C 71.193237 74.068626 71.178802 74.56221 71.056816 74.776978 C 70.699043 74.722656 70.695824 74.462753 71.059212 74.140327 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -26.620001, -48.419998)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(244,214,159)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-63.38, -41.59)",
    d: "M 62.876717 41.583549 C 62.981766 41.328217 63.301006 41.318367 63.830669 41.558289 C 64.0373 41.682968 63.56424 41.785179 63.56424 41.785179 C 63.56424 41.785179 63.087112 41.703945 62.876717 41.583549 z",
    strokeLinecap: "round"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -61.5, -15.1)"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -44.880001, 63.200001)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -33.419998, 59.459999)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(143,147,149)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-56.59, -149.46)",
    d: "M 46.98484 152.013107 C 47.657295 149.979034 48.329754 147.944946 49.01236 145.533691 C 49.771271 145.112503 50.520042 145.068481 51.810577 145.431778 C 56.572887 145.888763 60.793427 145.938431 65.308075 146.010941 C 65.798851 146.034271 65.995506 146.03479 66.18576 146.435104 C 65.769455 148.566193 65.359558 150.29747 64.492737 152.013992 C 59.999607 152.548752 55.963394 153.098267 51.614887 153.681366 C 50.885403 153.746796 50.468216 153.778641 49.925499 153.51767 C 48.861595 152.820953 47.923218 152.417038 46.98484 152.013107 z",
    strokeLinecap: "round"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -53.130001, 10.53)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -21.549999, 51.509998)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(109,124,124)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-68.45, -141.51)",
    d: "M 66.192169 146.035309 C 65.995506 146.03479 65.798851 146.034271 65.295303 145.749542 C 64.988823 145.290833 64.98922 145.116333 64.989616 144.941833 C 65.003792 142.580292 65.01796 140.218735 65.097885 137.418518 C 66.169197 136.968735 67.174767 136.957611 68.870148 136.999359 C 70.336693 137.386551 71.113426 137.720856 71.898376 138.448105 C 71.90844 139.893173 71.910286 140.945282 71.736359 142.216934 C 71.404846 142.973114 71.249115 143.509735 70.896988 144.261429 C 70.415375 144.742126 70.13015 145.007767 69.528717 145.271271 C 68.205727 145.524521 67.198952 145.779907 66.192169 146.035309 z",
    strokeLinecap: "round"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -35.139999, 26.92)"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -44.549999, 18.540001)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -31.41, 55.400002)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(154,153,156)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-58.59, -145.41)",
    d: "M 64.527534 144.964233 C 64.98922 145.116333 64.988823 145.290833 65.001198 145.726715 C 60.793427 145.938431 56.572887 145.888763 52.180138 145.501251 C 56.027103 145.104477 60.04628 145.045547 64.527534 144.964233 z",
    strokeLinecap: "round"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 66.510002, 24.379999)"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 68.43, 22.93)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 27.49, 44.150002)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(128,138,133)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-117.49, -134.16)",
    d: "M 113.966049 127.960487 C 113.987541 126.267578 114.009041 124.574677 114.075394 122.46669 C 116.129898 122.427124 118.139565 122.802628 120.55555 123.613434 C 120.97924 125.722755 120.996613 127.396759 121.013985 129.07077 C 121.015465 134.037445 121.016937 139.004105 120.830231 144.646027 C 120.107109 145.548187 119.572182 145.775116 118.844208 145.806335 C 117.808609 145.781006 116.966049 145.951355 115.942741 145.734879 C 115.514359 143.419693 115.220779 141.495911 115.028763 139.562042 C 114.645081 135.697784 114.317055 131.827988 113.966049 127.960487 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 38.02, 59.93)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(143,151,151)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-128.01, -149.93)",
    d: "M 119.037247 146.002045 C 119.572182 145.775116 120.107109 145.548187 120.841949 145.105591 C 126.162613 144.889938 131.283371 144.889938 136.991516 144.889938 C 136.991516 147.582016 136.991516 149.838242 136.733139 152.730057 C 135.653351 153.957901 134.831924 154.550171 133.675873 154.975311 C 129.672272 154.165268 126.003326 153.522339 122.219604 152.54303 C 121.082306 150.138443 120.059776 148.070251 119.037247 146.002045 z",
    strokeLinecap: "round"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 66.419998, -0.88)"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 49.34, 67.029999)"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 62.939999, -20.77)"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 58.09, -67.489998)"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 43.650002, -16.68)"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 35.48, 34.560001)"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 58.41, 12.99)"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 81.050003, 17.860001)"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 51.009998, -77.110001)"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 43.970001, 28)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 46.009998, -78.57)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(206,175,131)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-136.02, -11.42)",
    d: "M 137.009979 8.655419 C 138.043121 10.971802 139.055069 13.075336 140.100021 15.531012 C 138.345566 14.609007 136.558075 13.334864 134.461685 11.959291 C 133.59996 10.69428 133.04715 9.530697 132.200714 8.196664 C 131.907089 8.026215 131.929672 7.553955 131.934097 7.318205 C 133.339478 7.348977 134.740417 7.615498 136.48999 7.962008 C 136.838608 8.041996 136.988785 8.442573 137.009979 8.655419 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 49.77, -25.139999)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(207,174,136)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-139.77, -64.85)",
    d: "M 136.927155 66.533707 C 136.465607 66.980614 136.095642 67.019058 135.450241 67.07946 C 133.614166 63.908371 134.887527 62.347519 138.14975 62.670795 C 140.409836 62.89476 142.597061 63.854053 144.927612 64.858086 C 142.365189 65.529343 139.691986 65.827293 136.927155 66.533707 z",
    strokeLinecap: "round"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 49.490002, 27.450001)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -45.580002, -71.489998)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(220,172,110)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-44.43, -18.51)",
    d: "M 45.698906 17.162956 C 45.181602 18.034992 44.337799 18.93751 43.151855 19.86517 C 43.663944 18.991354 44.518173 18.092396 45.698906 17.162956 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 3.09, 68.07)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(29,113,94)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-93.09, -158.07)",
    d: "M 105.009506 160.076141 C 104.534264 160.08284 104.059013 160.089539 103.229134 160.14209 C 102.495598 160.163849 102.116684 160.139771 101.09848 159.937897 C 96.952484 159.183365 93.445786 158.606628 89.474884 158.028778 C 77.012703 158.030304 65.01474 158.032959 53.162422 157.669006 C 55.316189 156.865417 57.323032 156.055084 59.332615 156.048264 C 83.893875 155.964783 108.455544 155.999191 133.017105 156.003052 C 133.001495 156.433868 132.985886 156.864685 132.467194 157.633957 C 124.870605 157.981537 117.77211 157.847397 110.686897 158.094528 C 108.773727 158.161285 106.900871 159.384003 105.009506 160.076141 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15.39, 76.029999)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(54,130,114)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-74.6, -166.02)",
    d: "M 53.016773 158.035629 C 65.01474 158.032959 77.012703 158.030304 89.197342 158.232391 C 87.881691 158.801346 86.379364 159.165573 84.877037 159.529785 C 89.063789 160.479294 93.557709 159.985291 96.188957 164.516327 C 93.771217 165.668777 91.416107 166.513504 88.266518 167.643204 C 87.527657 169.820892 87.682144 172.023834 91.980446 172.2061 C 93.346519 172.264023 94.667679 173.381241 96.009392 174.013733 C 92.728432 174.013733 89.447472 174.013733 86.731087 174.013733 C 85.733749 170.998398 84.628105 167.655609 83.199158 164.113678 C 81.982391 159.969315 80.103798 157.694794 75.356323 159.844574 C 74.171761 160.062469 73.339424 160.124084 72.267014 160.090363 C 67.242081 159.83876 62.457237 159.682495 56.993927 159.702347 C 55.21764 159.588089 54.119816 159.297714 53.019676 158.764435 C 53.017357 158.5215 53.016773 158.035629 53.016773 158.035629 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 2.99, 79.389999)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(85,167,149)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-92.99, -169.39)",
    d: "M 96.007797 174.000153 C 94.667679 173.381241 93.346519 172.264023 91.980446 172.2061 C 87.682144 172.023834 87.527657 169.820892 88.266518 167.643204 C 91.416107 166.513504 93.771217 165.668777 96.487823 164.527069 C 97.249153 164.277512 97.648979 164.324936 98.048813 164.372375 C 97.845238 167.695267 97.641663 171.018173 97.075325 174.451691 C 96.516853 174.308151 96.27169 174.117615 95.977058 173.990692 C 95.977058 173.990692 96.006195 173.986588 96.007797 174.000153 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 2.85, 71.25)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(46,115,100)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-92.85, -161.25)",
    d: "M 98.254257 164.093048 C 97.648979 164.324936 97.249153 164.277512 96.550446 164.219345 C 93.557709 159.985291 89.063789 160.479294 84.877037 159.529785 C 86.379364 159.165573 87.881691 158.801346 89.66156 158.233521 C 93.445786 158.606628 96.952484 159.183365 100.813164 159.940079 C 100.264671 161.351288 99.362183 162.58252 98.254257 164.093048 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 6.45, 84.480003)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(54,130,114)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-96.45, -174.48)",
    d: "M 96.077881 174.205429 C 96.27169 174.117615 96.516853 174.308151 96.827774 174.766144 C 96.647018 174.843994 96.39225 174.660721 96.077881 174.205429 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 28.77, 70.330002)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(51,135,115)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-118.77, -160.34)",
    d: "M 105.124809 160.307587 C 106.900871 159.384003 108.773727 158.161285 110.686897 158.094528 C 117.77211 157.847397 124.870605 157.981537 132.420227 157.95401 C 132.430008 158.581421 131.983688 159.227249 131.238647 159.979309 C 129.923721 160.920624 128.907516 161.755707 127.623947 162.652115 C 125.825874 162.449036 124.295135 162.184616 122.37075 161.952911 C 121.547623 161.986862 121.118156 161.988129 120.367203 161.981018 C 118.901352 162.19313 117.756966 162.413574 116.332298 162.729645 C 112.992836 162.519104 109.93367 162.212952 106.42717 161.90358 C 105.733269 161.446579 105.486687 160.992798 105.124809 160.307587 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -35.189999, 70.489998)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(44,121,106)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-54.81, -160.49)",
    d: "M 53.021992 159.007355 C 54.119816 159.297714 55.21764 159.588089 56.651852 159.93222 C 56.766418 160.539124 56.54459 161.09227 56.10614 161.857849 C 55.14975 162.021973 54.409985 161.973679 53.296906 161.897186 C 52.92382 161.470551 52.924046 161.072128 52.959129 160.107391 C 53.003326 159.363174 53.012661 159.185257 53.021992 159.007355 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1.29, 66.339996)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(55,122,108)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-91.29, -156.34)",
    d: "M 53.019676 158.764435 C 53.012661 159.185257 53.003326 159.363174 52.973412 159.808289 C 52.449978 159.204056 51.947128 158.332642 50.976326 157.082001 C 48.972805 155.957397 47.19128 155.250885 50.051025 153.810471 C 50.468216 153.778641 50.885403 153.746796 52.069267 153.778198 C 56.85276 153.577744 60.869583 153.314026 65.229446 153.29834 C 66.214218 153.690781 66.855568 153.959427 67.497772 153.961487 C 84.383202 154.015579 101.268799 154.070297 118.154068 154.02124 C 119.548599 154.017197 120.940994 153.277374 122.334381 152.879425 C 126.003326 153.522339 129.672272 154.165268 133.675873 154.975311 C 134.010513 155.142441 134.0121 155.605194 134.012756 155.837341 C 134.013397 156.069504 133.515121 156.035767 133.266113 156.019409 C 108.455544 155.999191 83.893875 155.964783 59.332615 156.048264 C 57.323032 156.055084 55.316189 156.865417 53.162422 157.669006 C 53.016773 158.035629 53.017357 158.5215 53.019676 158.764435 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -41.110001, 66)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(112,146,139)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-48.88, -156.01)",
    d: "M 49.925499 153.51767 C 47.19128 155.250885 48.972805 155.957397 50.778683 156.852905 C 50.358673 157.769623 49.668358 158.536255 48.831192 159.576813 C 48.119717 157.51947 47.555088 155.188187 46.987648 152.434998 C 47.923218 152.417038 48.861595 152.820953 49.925499 153.51767 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 37.419998, -85.470001)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(206,175,131)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-127.42, -4.53)",
    d: "M 127.85891 4.843574 C 127.658562 4.8385 127.328812 4.625492 126.981812 4.224866 C 127.270981 4.17096 127.525963 4.370425 127.85891 4.843574 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 3.58, 59.799999)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(36,63,65)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-93.58, -149.79)",
    d: "M 122.219604 152.54303 C 120.940994 153.277374 119.548599 154.017197 118.154068 154.02124 C 101.268799 154.070297 84.383202 154.015579 67.497772 153.961487 C 66.855568 153.959427 66.214218 153.690781 65.266945 153.043747 C 64.957497 152.370331 64.953575 152.199554 64.949654 152.028763 C 65.359558 150.29747 65.769455 148.566193 66.18576 146.435104 C 67.198952 145.779907 68.205727 145.524521 69.635681 145.548492 C 70.70829 146.23526 71.357719 146.64267 72.461334 147.069504 C 75.95208 147.042953 78.988647 146.996979 82.319962 147.073792 C 84.033905 147.091721 85.45311 146.986847 87.165085 146.907288 C 87.653564 146.927094 87.849274 146.92157 88.33606 147.056854 C 90.11393 147.072845 91.600716 146.948044 93.464554 146.973221 C 95.161041 147.004135 96.480476 146.885071 98.122162 146.865387 C 99.957329 146.627762 101.470245 146.290741 103.27951 146.119354 C 104.438255 146.465439 105.300644 146.645874 106.163033 146.826324 C 108.51091 146.86528 110.85878 146.904251 113.889633 146.92453 C 115.089577 146.644485 115.606529 146.383102 116.123489 146.121719 C 116.966049 145.951355 117.808609 145.781006 118.844208 145.806335 C 120.059776 148.070251 121.082306 150.138443 122.219604 152.54303 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 9.61, 23.629999)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(38,121,102)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-99.61, -113.63)",
    d: "M 106.964218 119.98394 C 106.68293 122.781273 106.401649 125.578598 105.797409 128.751297 C 104.941376 128.823807 104.408279 128.520935 103.834778 127.894341 C 103.844101 125.347046 103.893829 123.123489 103.953888 120.535019 C 103.285881 119.481224 102.607559 118.792336 101.929237 118.103455 C 101.318535 119.01506 100.707825 119.926666 99.996719 121.149292 C 98.437378 122.090958 96.978424 122.721603 95.338196 123.430611 C 96.988602 125.403275 98.498528 127.208031 100.019363 129.356537 C 100.376534 131.474747 100.722809 133.249176 100.636505 135.019257 C 99.050766 135.03949 97.897606 135.064087 96.534378 134.809631 C 93.923553 129.494766 92.96656 124.422157 93.851288 118.683884 C 94.480629 114.602013 93.256882 110.24472 92.942337 106.004257 C 92.59742 101.354401 92.346863 96.69754 92.261284 92.225159 C 92.979866 92.928169 93.492348 93.449753 94.172592 94.258629 C 95.674782 95.98291 97.009224 97.419907 98.51004 99.036064 C 93.917122 102.031525 98.346016 102.526749 99.037384 102.997108 C 98.248451 106.940796 96.831558 110.246536 97.33712 113.226067 C 97.561134 114.546257 101.673691 115.206642 104.519379 116.370316 C 104.519379 113.284683 104.519379 111.622551 104.519379 109.960426 C 104.82325 109.953819 105.127113 109.947212 105.430984 109.940605 C 105.942062 113.288383 106.45314 116.636162 106.964218 119.98394 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 11.45, 16.540001)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(45,130,111)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-101.46, -106.54)",
    d: "M 107.191269 119.667122 C 106.45314 116.636162 105.942062 113.288383 105.430984 109.940605 C 105.127113 109.947212 104.82325 109.953819 104.519379 109.960426 C 104.519379 111.622551 104.519379 113.284683 104.519379 116.370316 C 101.673691 115.206642 97.561134 114.546257 97.33712 113.226067 C 96.831558 110.246536 98.248451 106.940796 99.037384 102.997108 C 98.346016 102.526749 93.917122 102.031525 98.51004 99.036064 C 97.009224 97.419907 95.674782 95.98291 94.272964 93.961708 C 95.353241 93.395828 96.507011 93.347252 97.64682 93.451454 C 98.770821 93.554199 99.880692 93.811615 101.308411 94.112198 C 102.480156 98.369835 103.340256 102.516449 104.316368 107.222351 C 104.995079 104.700699 105.492233 102.853592 105.989388 101.006485 C 110.044098 106.842346 108.605171 113.10614 107.191269 119.667122 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 16.49, -11.17)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(89,174,150)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-106.49, -78.83)",
    d: "M 110.746155 72.978836 C 111.36409 73.864594 111.641541 74.643974 111.994972 75.727646 C 111.763657 77.469521 111.456352 78.907097 110.650818 80.778084 C 105.67028 85.333351 107.121155 90.393425 107.859169 95.366119 C 107.801437 95.382347 107.602234 95.476326 107.602234 95.476326 C 107.262383 95.828758 106.922531 96.18119 106.218735 96.520309 C 105.80484 96.343658 105.754898 96.180313 105.763283 95.558273 C 105.724937 91.396599 105.628258 87.693626 105.630814 83.628227 C 106.222816 81.091469 108.303726 78.731201 104.908493 76.706917 C 104.425354 75.960182 104.030411 75.508232 103.686539 74.674103 C 102.818581 71.541191 101.899551 68.790482 100.98053 66.039764 C 101.411804 64.454697 101.843079 62.869629 102.59996 61.143166 C 105.418945 64.958656 107.912315 68.91555 110.746155 72.978836 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 11.54, 2.11)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(38,121,102)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-101.53, -92.11)",
    d: "M 105.704948 96.016975 C 105.754898 96.180313 105.80484 96.343658 105.932732 96.751022 C 105.992073 98.064674 105.973473 99.134308 105.972137 100.605209 C 105.492233 102.853592 104.995079 104.700699 104.316368 107.222351 C 103.340256 102.516449 102.480156 98.369835 101.362991 93.781792 C 102.504646 88.724998 96.735451 89.888962 96.266373 86.990067 C 96.721062 86.971794 96.902878 86.96302 97.483879 86.984062 C 98.965302 86.196945 100.047554 85.380013 101.124863 84.518463 C 101.119911 84.473831 101.134796 84.385277 101.19857 84.306335 C 101.262344 84.227394 101.402664 84.080757 101.652451 83.935776 C 102.933731 81.527771 103.96521 79.26474 104.996689 77.001709 C 108.303726 78.731201 106.222816 81.091469 105.363678 83.798584 C 102.723274 88.378563 102.538208 92.299255 105.704948 96.016975 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 18.860001, -0.55)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(74,155,136)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-108.85, -89.45)",
    d: "M 107.916901 95.349899 C 107.121155 90.393425 105.67028 85.333351 110.491013 81.11409 C 110.738159 86.495842 110.646873 91.974983 110.291992 97.795013 C 109.411537 97.492104 108.794685 96.84832 108.037949 95.837936 C 107.898079 95.471336 107.916901 95.349899 107.916901 95.349899 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 11.14, 50.790001)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(45,125,108)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-101.15, -140.79)",
    d: "M 96.744446 135.088684 C 97.897606 135.064087 99.050766 135.03949 100.634338 135.396454 C 101.691124 137.1772 102.317513 138.576401 103.271172 139.9823 C 104.242401 140.006119 104.886353 140.023239 105.530304 140.040344 C 105.560806 140.469223 105.591316 140.898132 105.266495 141.685944 C 103.067276 142.736481 101.223381 143.428116 98.160431 144.576996 C 100.717674 145.307007 101.850418 145.630356 102.983162 145.95372 C 101.470245 146.290741 99.957329 146.627762 98.13517 146.442841 C 97.465431 142.310181 97.104935 138.699432 96.744446 135.088684 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 24.08, 47.389999)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(97,161,148)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-114.08, -137.4)",
    d: "M 115.942741 145.734879 C 115.606529 146.383102 115.089577 146.644485 114.26651 146.850555 C 113.314499 144.443207 112.668587 142.091141 112.215714 139.208832 C 112.645302 138.47934 112.840279 138.245422 112.99369 137.976852 C 112.993332 137.543274 112.992966 137.109695 112.993362 135.902008 C 113.010445 132.733047 113.026787 130.338181 113.043121 127.943329 C 113.043121 127.943329 113.504433 127.973236 113.735245 127.966858 C 114.317055 131.827988 114.645081 135.697784 115.028763 139.562042 C 115.220779 141.495911 115.514359 143.419693 115.942741 145.734879 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 20.360001, 38.380001)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(88,173,153)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-110.36, -128.37)",
    d: "M 111.95092 136.00032 C 108.975975 134.438202 107.753906 127.763641 109.723808 123.521568 C 110.20713 122.480759 110.906281 121.540154 111.748047 120.746384 C 111.976913 125.959641 111.963913 130.97998 111.95092 136.00032 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 13.17, 44.099998)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(79,163,144)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-103.16, -134.1)",
    d: "M 102.943893 139.975586 C 102.317513 138.576401 101.691124 137.1772 101.06691 135.400818 C 100.722809 133.249176 100.376534 131.474747 100.326508 129.213806 C 101.706902 128.557556 102.791046 128.387817 103.875191 128.218079 C 104.408279 128.520935 104.941376 128.823807 105.788055 129.169403 C 106.084839 129.906845 106.068024 130.601547 105.723068 131.617706 C 104.883469 132.649567 104.372017 133.35994 103.800957 134.437073 C 103.475533 136.527756 103.209717 138.251678 102.943893 139.975586 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 12.15, 54.27)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(45,130,111)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-102.15, -144.26)",
    d: "M 103.27951 146.119354 C 101.850418 145.630356 100.717674 145.307007 98.160431 144.576996 C 101.223381 143.428116 103.067276 142.736481 105.241577 142.007874 C 105.75119 143.31897 105.930389 144.667068 106.136314 146.420746 C 105.300644 146.645874 104.438255 146.465439 103.27951 146.119354 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 22.530001, 37.150002)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(109,184,165)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-112.54, -127.16)",
    d: "M 112.210175 136.006729 C 111.963913 130.97998 111.976913 125.959641 111.977966 120.473328 C 111.970016 119.556496 111.973999 119.105637 111.979065 118.316315 C 112.332367 118.232491 112.684593 118.487137 113.096832 118.942078 C 113.105843 121.781876 113.054825 124.421379 113.023468 127.502106 C 113.026787 130.338181 113.010445 132.733047 112.991035 135.576843 C 112.815117 136.021561 112.642281 136.017349 112.210175 136.006729 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 14.49, 46.98)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(45,130,111)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-104.49, -136.97)",
    d: "M 103.271179 139.9823 C 103.209717 138.251678 103.475533 136.527756 104.111603 134.41507 C 104.892273 134.00322 105.302689 133.980164 105.713104 133.957092 C 105.72171 135.699158 105.730324 137.441223 105.634613 139.611816 C 104.886353 140.023239 104.242401 140.006119 103.271179 139.9823 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 15.02, 43.009998)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(38,121,102)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-105.03, -133.01)",
    d: "M 105.780853 133.633163 C 105.302689 133.980164 104.892273 134.00322 104.171211 134.048309 C 104.372017 133.35994 104.883469 132.649567 105.69902 131.966888 C 105.951622 132.4328 105.900116 132.871017 105.780853 133.633163 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 20.91, 14.42)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(96,166,144)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-110.91, -104.43)",
    d: "M 110.80658 104.120529 C 110.938576 104.009491 110.99147 104.505753 111.00856 104.754456 C 110.90863 104.745972 110.791611 104.48877 110.80658 104.120529 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 22.52, 48.459999)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(109,184,165)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-112.52, -138.46)",
    d: "M 112.812149 138.11496 C 112.840279 138.245422 112.645302 138.47934 112.220299 138.806595 C 112.202171 138.681732 112.401764 138.454559 112.812149 138.11496 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 17.790001, 5.46)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(45,130,111)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-107.78, -95.46)",
    d: "M 107.859169 95.366119 C 107.916901 95.349899 107.898079 95.471336 107.907654 95.526451 C 107.917221 95.581566 107.738602 95.574944 107.670418 95.525635 C 107.602234 95.476326 107.801437 95.382347 107.859169 95.366119 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5.36, -27.299999)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(45,131,112)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-84.65, -62.7)",
    d: "M 93.089897 58.957745 C 93.107925 59.124634 93.125946 59.291519 92.779938 59.837902 C 90.642738 63.622238 88.869576 67.027077 86.973022 70.635696 C 86.3937 71.261894 85.937775 71.684319 85.100754 72.061432 C 83.783051 71.292534 82.846451 70.568947 81.909851 69.84536 C 81.043343 68.842232 80.190735 67.82666 79.306786 66.839142 C 78.217827 65.622597 76.563469 64.567162 76.207367 63.172916 C 76.003609 62.375149 78.103333 61.159077 78.788559 59.922249 C 79.694786 58.286503 80.231476 56.44603 81.365463 53.588768 C 81.724159 53.533108 83.438019 53.267162 85.622391 53.359753 C 88.076485 55.156342 90.060081 56.594398 92.18676 58.219212 C 92.545792 58.641403 92.799141 58.825329 93.089897 58.957745 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -11.37, -10.98)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(40,121,102)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-78.63, -79.01)",
    d: "M 81.579399 69.885811 C 82.846451 70.568947 83.783051 71.292534 84.911179 72.381355 C 81.524086 77.230904 80.729317 82.460938 80.681641 88.042694 C 78.535896 88.074684 76.730042 88.046135 74.599136 88.017754 C 73.633133 88.057823 72.992203 88.097725 72.351265 88.137627 C 72.360626 85.291344 72.369987 82.445068 72.904129 79.303375 C 75.148529 78.084343 77.441086 77.559387 78.435074 76.130859 C 79.545418 74.535133 79.477257 72.1194 79.921997 70.060539 C 80.364311 70.015778 80.806633 69.971024 81.579399 69.885811 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0.09, -38.529999)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(36,100,88)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-90.09, -51.47)",
    d: "M 92.043671 58.032455 C 90.060081 56.594398 88.076485 55.156342 86.003136 53.385429 C 86.298149 51.241234 86.682915 49.429893 87.443573 47.26878 C 88.885933 46.617298 89.9524 46.31559 91.308952 45.949394 C 92.083534 45.556637 92.568039 45.228363 93.052551 44.900093 C 93.365814 45.075928 93.679077 45.251762 94.176613 45.629005 C 93.907562 49.632393 93.454231 53.434368 93.030807 57.638954 C 93.060707 58.041569 93.048531 58.045792 92.796562 58.032059 C 92.377625 58.023037 92.210648 58.027744 92.043671 58.032455 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 2.55, -50.560001)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(44,114,101)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-92.54, -39.44)",
    d: "M 93.038559 44.529053 C 92.568039 45.228363 92.083534 45.556637 91.301819 45.558365 C 91.239296 42.340042 90.202705 40.410572 87.086281 40.05547 C 87.393333 38.915005 87.700394 37.774536 88.018311 36.273338 C 88.300758 35.149117 88.57235 34.385628 88.893639 33.320679 C 91.85598 34.617611 96.413193 32.593319 97.999825 37.461998 C 96.345886 39.917007 94.685226 42.03751 93.038559 44.529053 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -13.85, -15.5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(47,130,110)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-76.16, -74.5)",
    d: "M 79.557281 70.053589 C 79.477257 72.1194 79.545418 74.535133 78.435074 76.130859 C 77.441086 77.559387 75.148529 78.084343 73.101471 78.945129 C 72.872032 77.848534 72.970016 76.814766 73.047279 75.08622 C 72.956001 74.199661 72.885445 74.007889 72.814896 73.816109 C 72.814896 73.816109 72.766251 73.804031 72.753296 73.783829 C 74.891075 72.524635 77.041817 71.285645 79.557281 70.053589 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -0.95, -46.32)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(45,127,110)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-89.05, -43.67)",
    d: "M 87.050354 40.480049 C 90.202705 40.410572 91.239296 42.340042 91.011749 45.622856 C 89.9524 46.31559 88.885933 46.617298 87.479713 46.870571 C 87.098122 44.849636 87.056274 42.877132 87.050354 40.480049 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 56.650002, -23.76)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(218,170,110)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-146.65, -66.23)",
    d: "M 147.05542 66.543442 C 146.755524 66.616165 146.503494 66.428177 146.251678 65.905853 C 146.457993 65.912773 146.741791 66.149841 147.05542 66.543442 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 55.919998, 14.47)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(209,176,129)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-145.92, -104.47)",
    d: "M 147.744812 102.122902 C 146.853424 103.618134 145.626938 105.150551 144.085663 106.8228 C 144.983826 105.361786 146.196777 103.760933 147.744812 102.122902 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 48.18, 23.559999)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(186,176,165)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-138.18, -113.56)",
    d: "M 140.000702 113.682083 C 139.497986 114.255531 138.995972 114.511047 138.241272 114.892227 C 137.555313 115.017456 137.122025 115.017029 136.364105 115.016327 C 137.134033 114.048569 138.228607 113.0811 139.66478 112.103973 C 140.004715 112.517601 140.003052 112.94088 140.000702 113.682083 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -61.52, -37.48)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(220,172,110)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-28.48, -52.52)",
    d: "M 29.533333 51.058792 C 29.122639 51.927116 28.449093 52.936508 27.430466 53.982216 C 27.813751 53.078972 28.542116 52.139412 29.533333 51.058792 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -59.150002, -46.650002)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(220,172,110)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-30.85, -43.34)",
    d: "M 31.507996 41.816475 C 31.371155 42.671722 30.957344 43.721123 30.190666 44.869205 C 30.30221 43.982136 30.766619 42.99638 31.507996 41.816475 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 6.21, -19.51)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(65,100,78)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-96.21, -70.49)",
    d: "M 100.647064 66.02504 C 101.899551 68.790482 102.818581 71.541191 103.456673 74.80278 C 102.132912 75.262688 101.090088 75.211723 99.798615 74.927185 C 96.380188 74.792763 93.210388 74.891922 89.959518 74.68177 C 89.515686 73.852814 89.152931 73.333153 88.959587 72.535126 C 90.499641 70.893883 91.870277 69.531013 93.240921 68.168152 C 94.296829 67.471268 95.352737 66.774376 97.038681 65.99942 C 98.109177 65.895813 98.549629 65.870285 98.990089 65.844757 C 99.431259 65.89994 99.872421 65.955124 100.647064 66.02504 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -3.01, -12.57)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(95,175,159)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-86.98, -77.43)",
    d: "M 93.000076 67.980347 C 91.870277 69.531013 90.499641 70.893883 88.685143 72.752182 C 86.810997 78.157372 85.380714 83.067131 83.951347 87.953049 C 83.952263 87.929207 83.905815 87.940163 83.550934 87.965317 C 82.485359 87.971588 81.774681 87.952713 81.037521 87.93206 C 81.011055 87.930283 81.021538 87.982147 81.021538 87.982147 C 80.729317 82.460938 81.524086 77.230904 85.292282 72.426666 C 85.937775 71.684319 86.3937 71.261894 87.242813 70.421967 C 89.075859 68.962578 90.515717 67.9207 91.955574 66.878822 C 92.223465 67.183388 92.491356 67.487961 93.000076 67.980347 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1.17, -24.85)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(40,121,102)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-91.17, -65.15)",
    d: "M 92.151276 66.649094 C 90.515717 67.9207 89.075859 68.962578 87.366211 70.218185 C 88.869576 67.027077 90.642738 63.622238 92.756798 60.088623 C 93.509789 61.244324 93.921867 62.528793 94.666595 63.909439 C 94.999252 64.005615 94.966682 63.979424 94.96669 63.979427 C 94.093445 64.79274 93.220207 65.606056 92.151276 66.649094 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 8.13, -24.25)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(95,175,159)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-98.13, -65.74)",
    d: "M 98.916916 65.61235 C 98.549629 65.870285 98.109177 65.895813 97.338654 65.893356 C 97.620316 65.70356 98.232025 65.541748 98.916916 65.61235 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 5.07, -26.129999)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(40,121,102)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-95.07, -63.87)",
    d: "M 95.012848 64.021538 C 95.026443 64.03746 95.142395 63.717186 95.142395 63.717186 C 95.142395 63.717186 95.137329 63.917347 95.052002 63.948387 C 94.966682 63.979424 94.999252 64.005615 95.012848 64.021538 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 2.64, -31.610001)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(68,127,118)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-92.64, -58.39)",
    d: "M 92.18676 58.219212 C 92.210648 58.027744 92.377625 58.023037 92.794594 58.039268 C 93.044594 58.060207 93.081802 58.508564 93.085846 58.733154 C 92.799141 58.825329 92.545792 58.641403 92.18676 58.219212 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 15.49, -27.49)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(89,174,150)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-105.48, -62.52)",
    d: "M 105.484039 62.515564 C 105.460487 62.525955 105.507591 62.505169 105.484039 62.515564 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -13.44, 34.709999)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(42,133,111)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-76.56, -124.71)",
    d: "M 82.025223 146.951004 C 78.988647 146.996979 75.95208 147.042953 72.451126 146.742859 C 71.688965 145.613312 71.391174 144.829849 71.093384 144.046371 C 71.249115 143.509735 71.404846 142.973114 71.998596 141.936127 C 72.958824 137.28685 73.481041 133.137939 74.003677 128.589355 C 73.672119 126.125175 73.340157 124.060631 73.008202 121.996094 C 72.982002 120.942352 72.955811 119.888611 73.093887 118.25827 C 72.948654 117.110283 72.639137 116.538895 72.32962 115.967506 C 72.260025 111.5896 72.190422 107.211693 72.527596 102.436371 C 74.315201 105.031258 75.696045 108.02356 77.120132 111.430817 C 77.789383 119.229767 78.199135 126.640945 79.122849 133.987503 C 79.672768 138.36116 81.030609 142.633255 82.025223 146.951004 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -14.58, 11.67)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(53,143,126)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-75.42, -101.67)",
    d: "M 77.076881 111.015854 C 75.696045 108.02356 74.315201 105.031258 72.590363 101.969093 C 72.220657 98.938354 72.194946 95.977486 72.542236 92.541847 C 73.59864 92.060883 74.282051 92.054695 74.96904 92.479973 C 75.642197 96.285789 76.311752 99.660141 77.054596 103.402451 C 77.694542 106.248756 78.261208 108.727104 78.536285 111.167976 C 77.855423 111.092278 77.466156 111.054062 77.076881 111.015854 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -17.17, 35.450001)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(40,121,102)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-72.82, -125.45)",
    d: "M 72.750168 122.016525 C 73.340157 124.060631 73.672119 126.125175 73.699448 128.590652 C 72.990616 128.986816 72.586426 128.98204 72.150711 128.581924 C 72.062195 127.13237 72.005211 126.078156 71.948219 125.023941 C 71.970444 124.294304 71.992676 123.564667 71.997314 122.47287 C 72.150536 122.086128 72.321342 122.061546 72.750168 122.016525 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -16.43, -0.96)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(53,143,126)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-73.57, -89.04)",
    d: "M 72.311401 88.420418 C 72.992203 88.097725 73.633133 88.057823 74.60331 88.33551 C 74.93605 89.07618 74.939552 89.49926 74.610954 89.935608 C 73.62207 89.914787 72.965286 89.880714 72.30851 89.846634 C 72.296188 89.465492 72.283859 89.084351 72.311401 88.420418 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -16.41, 1.05)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(40,121,102)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-73.59, -91.04)",
    d: "M 72.239281 90.224182 C 72.965286 89.880714 73.62207 89.914787 74.627502 90.290382 C 74.972588 91.104095 74.969017 91.576302 74.965454 92.048508 C 74.282051 92.054695 73.59864 92.060883 72.579018 92.098976 C 72.218552 91.621162 72.194305 91.111443 72.239281 90.224182 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -17.299999, 27.059999)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(40,121,102)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-72.7, -117.06)",
    d: "M 72.299179 116.24823 C 72.639137 116.538895 72.948654 117.110283 73.096436 117.862991 C 72.712708 117.539185 72.490715 117.034065 72.299179 116.24823 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -17.389999, -15.74)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(64,97,70)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-72.62, -74.26)",
    d: "M 72.594872 73.771667 C 72.885445 74.007889 72.956001 74.199661 73.067566 74.695618 C 72.822571 74.847038 72.571335 74.64994 72.202576 74.222946 C 72.05027 74.037384 72.374847 73.727219 72.594872 73.771667 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -19.5, 41.59)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(103,146,139)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-70.5, -131.59)",
    d: "M 71.581863 125.115707 C 72.005211 126.078156 72.062195 127.13237 72.09864 129.033234 C 72.015457 132.60498 71.952812 135.330063 71.890167 138.055145 C 71.113426 137.720856 70.336693 137.386551 69.246956 136.982697 C 69.933235 133.0578 66.879555 128.412491 71.581863 125.115707 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 53.110001, -71.75)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(220,172,106)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-143.11, -18.25)",
    d: "M 141.149933 17.226171 C 141.449127 16.910019 141.893906 16.914925 142.672119 16.910542 C 143.658356 17.703665 144.311142 18.506077 145.07077 19.598705 C 143.883591 19.108355 142.589554 18.327793 141.149933 17.226171 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -31.34, 62.880001)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(112,146,139)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-58.66, -152.88)",
    d: "M 64.492737 152.013992 C 64.953575 152.199554 64.957497 152.370331 64.923904 152.795715 C 60.869583 153.314026 56.85276 153.577744 52.381561 153.744629 C 55.963394 153.098267 59.999607 152.548752 64.492737 152.013992 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -17.200001, 45.349998)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(51,113,102)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-72.8, -135.35)",
    d: "M 71.898376 138.448105 C 71.952812 135.330063 72.015457 132.60498 72.130157 129.428589 C 72.586426 128.98204 72.990616 128.986816 73.699036 128.990295 C 73.481041 133.137939 72.958824 137.28685 72.17437 141.716583 C 71.910286 140.945282 71.90844 139.893173 71.898376 138.448105 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -19.030001, 55.490002)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(51,113,102)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-70.97, -145.49)",
    d: "M 70.896988 144.261429 C 71.391174 144.829849 71.688965 145.613312 71.996948 146.723434 C 71.357719 146.64267 70.70829 146.23526 69.951889 145.550629 C 70.13015 145.007767 70.415375 144.742126 70.896988 144.261429 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4.71, 22.48)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(94,180,160)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-94.71, -112.49)",
    d: "M 96.534378 134.809631 C 97.104935 138.699432 97.465431 142.310181 97.81292 146.343475 C 96.480476 146.885071 95.161041 147.004135 93.479156 146.722839 C 93.113205 145.98793 93.109703 145.653351 93.328987 144.985077 C 93.093193 141.755432 92.634613 138.859497 92.006912 135.611389 C 91.133972 130.503448 90.430161 125.747658 89.895897 120.782722 C 89.27877 120.051254 88.492096 119.528923 88.020645 118.749176 C 89.28437 117.205681 90.982498 115.948036 91.032578 114.627876 C 91.154266 111.420067 90.510162 108.183205 90.143387 104.539261 C 90.029091 98.73835 89.945953 93.356239 89.900314 87.557236 C 90.195915 79.005066 90.96833 78.290817 100.148499 78.104149 C 100.688881 80.253578 101.045769 82.167168 101.402664 84.080757 C 101.402664 84.080757 101.262344 84.227394 101.09465 84.285233 C 100.926964 84.343079 100.85305 84.540558 100.85305 84.540558 C 100.85305 84.540558 101.129807 84.563087 101.129807 84.563087 C 100.047554 85.380013 98.965302 86.196945 97.300735 86.711731 C 95.784782 85.654831 94.851158 84.900085 92.836563 83.271484 C 92.543434 86.675423 92.35836 88.824585 92.139465 91.240776 C 92.088821 91.68644 92.072006 91.865089 92.055183 92.043732 C 92.346863 96.69754 92.59742 101.354401 92.942337 106.004257 C 93.256882 110.24472 94.480629 114.602013 93.851288 118.683884 C 92.96656 124.422157 93.923553 129.494766 96.534378 134.809631 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -8, 39.119999)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(89,177,156)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-82, -129.12)",
    d: "M 77.120132 111.430817 C 77.466156 111.054062 77.855423 111.092278 78.579575 111.496605 C 79.184334 112.927757 79.454208 113.99279 79.756126 115.426773 C 79.848625 116.534462 79.909088 117.273209 79.946823 118.34552 C 79.956718 119.123192 79.989342 119.567291 80.014915 120.358536 C 80.945763 125.50325 81.883652 130.300827 82.866455 135.475739 C 84.231682 139.529373 85.551994 143.205673 86.872307 146.881973 C 85.45311 146.986847 84.033905 147.091721 82.319962 147.073792 C 81.030609 142.633255 79.672768 138.36116 79.122849 133.987503 C 78.199135 126.640945 77.789383 119.229767 77.120132 111.430817 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -0.76, 50.549999)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(66,152,133)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-89.25, -140.56)",
    d: "M 93.106201 145.318787 C 93.109703 145.653351 93.113205 145.98793 93.102112 146.572876 C 91.600716 146.948044 90.11393 147.072845 88.340027 146.666046 C 87.076401 142.465149 86.099869 138.795868 85.38443 135.051422 C 86.103561 134.690186 86.561607 134.404099 87.302444 134.192871 C 88.049774 134.84523 88.514313 135.422729 89.106544 136.334656 C 90.524895 139.552322 91.815544 142.435562 93.106201 145.318787 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.36, 50.970001)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(45,131,111)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-85.64, -140.97)",
    d: "M 85.123344 135.126572 C 86.099869 138.795868 87.076401 142.465149 88.04895 146.525238 C 87.849274 146.92157 87.653564 146.927094 87.165085 146.907288 C 85.551994 143.205673 84.231682 139.529373 83.230011 135.458984 C 84.031525 135.042648 84.514404 135.020401 85.028885 135.030197 C 85.060478 135.062225 85.123344 135.126572 85.123344 135.126572 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 6.71, 0.36)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(49,132,111)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-96.71, -90.36)",
    d: "M 92.261284 92.225159 C 92.072006 91.865089 92.088821 91.68644 92.434578 91.120796 C 93.840172 89.489052 94.91684 88.244316 95.9935 86.999573 C 96.735451 89.888962 102.504646 88.724998 101.051346 93.670769 C 99.880692 93.811615 98.770821 93.554199 97.64682 93.451454 C 96.507011 93.347252 95.353241 93.395828 94.105209 93.674416 C 93.492348 93.449753 92.979866 92.928169 92.261284 92.225159 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 9.64, 34.889999)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(45,130,111)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-99.64, -124.88)",
    d: "M 103.834778 127.894341 C 102.791046 128.387817 101.706902 128.557556 100.315605 128.870041 C 98.498528 127.208031 96.988602 125.403275 95.338196 123.430611 C 96.978424 122.721603 98.437378 122.090958 100.258011 121.302727 C 101.727654 121.063408 102.835609 120.981674 103.943573 120.899933 C 103.893829 123.123489 103.844101 125.347046 103.834778 127.894341 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 12.16, 29.559999)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(104,182,165)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-102.16, -119.56)",
    d: "M 103.953888 120.535019 C 102.835609 120.981674 101.727654 121.063408 100.358398 120.991699 C 100.707825 119.926666 101.318535 119.01506 101.929237 118.103455 C 102.607559 118.792336 103.285881 119.481224 103.953888 120.535019 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 12.48, -10.45)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(45,130,111)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-102.47, -79.55)",
    d: "M 101.652451 83.935776 C 101.045769 82.167168 100.688881 80.253578 100.163467 77.764984 C 100.01239 76.51358 100.029823 75.837166 100.047256 75.160759 C 101.090088 75.211723 102.132912 75.262688 103.405609 75.184967 C 104.030411 75.508232 104.425354 75.960182 104.908493 76.706917 C 103.96521 79.26474 102.933731 81.527771 101.652451 83.935776 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 14.56, -0.14)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(45,130,111)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-104.56, -89.86)",
    d: "M 105.763283 95.558273 C 102.538208 92.299255 102.723274 88.378563 105.26445 84.161011 C 105.628258 87.693626 105.724937 91.396599 105.763283 95.558273 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4.67, -2.94)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(45,130,111)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-94.67, -87.06)",
    d: "M 96.26638 86.990074 C 94.91684 88.244316 93.840172 89.489052 92.468399 90.853775 C 92.35836 88.824585 92.543434 86.675423 92.836563 83.271484 C 94.851158 84.900085 95.784782 85.654831 96.901558 86.681915 C 96.902878 86.96302 96.721062 86.971794 96.26638 86.990074 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 10.99, -5.55)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(45,130,111)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-100.99, -84.45)",
    d: "M 101.124863 84.518463 C 101.129807 84.563087 100.85305 84.540558 100.85305 84.540558 C 100.85305 84.540558 100.926964 84.343079 101.030884 84.364182 C 101.134796 84.385277 101.119911 84.473831 101.124863 84.518463 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -12.03, 5.52)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(33,115,96)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-77.96, -95.52)",
    d: "M 74.96904 92.479965 C 74.969017 91.576302 74.972588 91.104095 74.95961 90.277122 C 74.939552 89.49926 74.93605 89.07618 74.928375 88.335342 C 76.730042 88.046135 78.535896 88.074684 80.681641 88.042694 C 81.021538 87.982147 81.011055 87.930283 80.994797 88.29805 C 80.103615 90.247108 79.556694 92.193398 78.286507 93.334854 C 75.516441 95.824196 76.247002 97.424576 79.071548 99.331352 C 79.129883 100.458214 79.157631 101.208992 78.904793 102.082466 C 78.076576 102.481613 77.528946 102.758049 76.981316 103.034485 C 76.311752 99.660141 75.642197 96.285789 74.96904 92.479965 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1.96, -8.08)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(39,111,95)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-91.95, -81.92)",
    d: "M 99.798622 74.927185 C 100.029823 75.837166 100.01239 76.51358 99.979988 77.529144 C 90.96833 78.290817 90.195915 79.005066 89.553864 87.569458 C 88.10408 88.345154 87.038246 88.691742 85.678482 88.978424 C 84.891632 88.592392 84.39872 88.266281 83.905815 87.940163 C 83.905815 87.940163 83.952263 87.929207 84.273155 87.806946 C 89.673279 84.853874 89.53933 79.786201 90.040596 74.991074 C 93.210388 74.891922 96.380188 74.792763 99.798622 74.927185 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -2.89, -9.57)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(43,127,107)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-87.12, -80.43)",
    d: "M 89.959518 74.681778 C 89.53933 79.786201 89.673279 84.853874 84.27224 87.83078 C 85.380714 83.067131 86.810997 78.157372 88.515724 73.030563 C 89.152931 73.333153 89.515686 73.852814 89.959518 74.681778 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -8.92, 3.46)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(49,137,115)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-81.08, -93.46)",
    d: "M 83.550934 87.965317 C 84.39872 88.266281 84.891632 88.592392 85.618912 89.335297 C 84.574684 91.834221 83.296089 93.916344 81.667038 96.027679 C 80.558037 97.02301 79.7995 97.989136 79.040962 98.955261 C 76.247002 97.424576 75.516441 95.824196 78.286507 93.334854 C 79.556694 92.193398 80.103615 90.247108 81.021263 88.29982 C 81.774681 87.952713 82.485359 87.971588 83.550934 87.965317 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9.48, 18.49)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(45,131,111)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-80.53, -108.5)",
    d: "M 77.054596 103.402443 C 77.528946 102.758049 78.076576 102.481613 79.180084 102.051407 C 79.921356 101.881302 80.10675 101.86496 80.254723 102.208397 C 80.754837 103.540169 81.292374 104.512161 81.976753 105.712204 C 82.744972 106.287506 83.366341 106.634773 83.998795 107.203537 C 84.009872 107.425049 84.025803 107.86834 83.783386 108.101517 C 82.934784 110.577881 82.32859 112.821053 81.390244 115.054604 C 80.613419 115.049263 80.168755 115.053551 79.724091 115.057831 C 79.454208 113.99279 79.184334 112.927757 78.871155 111.534088 C 78.261208 108.727104 77.694542 106.248756 77.054596 103.402443 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5.19, 36)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(45,131,111)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-84.81, -126)",
    d: "M 87.019661 134.118011 C 86.561607 134.404099 86.103561 134.690186 85.38443 135.051422 C 85.123344 135.126572 85.060478 135.062225 84.867111 134.695282 C 83.788391 131.051376 82.978226 127.751373 81.985046 124.507401 C 81.509453 122.954002 80.68721 121.506737 80.021957 120.011398 C 79.989342 119.567291 79.956718 119.123192 80.288834 118.329102 C 81.456635 117.614609 82.259689 117.250114 83.421997 116.915596 C 84.501709 116.931267 85.222153 116.916954 86.017776 117.186653 C 86.63044 117.982643 87.167931 118.494614 87.705421 119.006592 C 88.492096 119.528923 89.27877 120.051254 89.613663 120.935394 C 86.573746 125.25766 84.91124 129.372803 87.019661 134.118011 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.04, 6.38)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(39,125,105)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-85.96, -96.37)",
    d: "M 82.017494 95.998474 C 83.296089 93.916344 84.574684 91.834221 85.912849 89.395218 C 87.038246 88.691742 88.10408 88.345154 89.516365 87.986343 C 89.945953 93.356239 90.029091 98.73835 89.693863 104.542419 C 88.08886 104.88826 86.902214 104.812149 85.745667 104.38987 C 85.226433 102.575798 84.677086 101.107895 84.010117 99.356277 C 83.267494 98.047874 82.642494 97.02317 82.017494 95.998474 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -2.46, 21.719999)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(34,116,97)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-87.54, -111.72)",
    d: "M 85.715569 104.736038 C 86.902214 104.812149 88.08886 104.88826 89.725029 104.961212 C 90.510162 108.183205 91.154266 111.420067 91.032578 114.627876 C 90.982498 115.948036 89.28437 117.205681 88.020645 118.749176 C 87.167931 118.494614 86.63044 117.982643 86.092979 116.836197 C 86.675682 113.108452 89.463692 109.468124 84.025803 107.86834 C 84.025803 107.86834 84.009872 107.425049 84.171196 106.974838 C 84.744835 105.928001 85.157158 105.331367 85.606247 104.707047 C 85.643021 104.679367 85.715569 104.736038 85.715569 104.736038 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -1.12, 38.57)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(35,116,98)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-88.88, -128.57)",
    d: "M 87.302444 134.192871 C 84.91124 129.372803 86.573746 125.25766 89.444122 121.144531 C 90.430161 125.747658 91.133972 130.503448 91.606323 135.620728 C 90.576195 135.988205 89.777519 135.994202 88.978851 136.000214 C 88.514313 135.422729 88.049774 134.84523 87.302444 134.192871 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1.22, 50.48)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(32,120,100)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-91.22, -140.48)",
    d: "M 89.106544 136.334656 C 89.777519 135.994202 90.576195 135.988205 91.775452 135.97287 C 92.634613 138.859497 93.093193 141.755432 93.328979 144.985077 C 91.815544 142.435562 90.524895 139.552322 89.106544 136.334656 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -7.58, 37.720001)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(34,116,97)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-82.43, -127.72)",
    d: "M 80.014908 120.358536 C 80.68721 121.506737 81.509453 122.954002 81.985046 124.507401 C 82.978226 127.751373 83.788391 131.051376 84.83551 134.663269 C 84.514404 135.020401 84.031525 135.042648 83.185097 135.081635 C 81.883652 130.300827 80.945763 125.50325 80.014908 120.358536 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -8.59, 26.559999)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(34,116,97)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-81.41, -116.56)",
    d: "M 83.062744 116.885612 C 82.259689 117.250114 81.456635 117.614609 80.311569 117.995529 C 79.909088 117.273209 79.848625 116.534462 79.756126 115.426773 C 80.168755 115.053551 80.613419 115.049263 81.551109 115.289246 C 82.383675 115.984222 82.723213 116.434914 83.062744 116.885612 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -8.59, 8.98)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(67,154,134)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-81.41, -98.98)",
    d: "M 81.667038 96.027679 C 82.642494 97.02317 83.267494 98.047874 83.747124 99.563766 C 82.49855 100.652855 81.395348 101.25074 80.292145 101.848625 C 80.10675 101.86496 79.921356 101.881302 79.460663 101.928696 C 79.157631 101.208992 79.129883 100.458214 79.071548 99.331352 C 79.7995 97.989136 80.558037 97.02301 81.667038 96.027679 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5.42, 22.51)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(89,177,158)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-84.58, -112.51)",
    d: "M 83.421997 116.915596 C 82.723213 116.434914 82.383675 115.984222 81.88327 115.298874 C 82.32859 112.821053 82.934784 110.577881 83.783386 108.101517 C 89.463692 109.468124 86.675682 113.108452 86.017807 116.552185 C 85.222153 116.916954 84.501709 116.931267 83.421997 116.915596 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -7, 12.67)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(98,185,165)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-83, -102.67)",
    d: "M 80.254723 102.208397 C 81.395348 101.25074 82.49855 100.652855 83.864746 99.847473 C 84.677086 101.107895 85.226433 102.575798 85.745667 104.389877 C 85.715569 104.736038 85.643021 104.679367 85.238129 104.747543 C 83.83213 105.038528 82.831017 105.261345 81.82991 105.484161 C 81.292374 104.512161 80.754837 103.540169 80.254723 102.208397 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -6.41, 15.77)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(67,154,134)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-83.59, -105.76)",
    d: "M 81.976753 105.712204 C 82.831017 105.261345 83.83213 105.038528 85.201355 104.775223 C 85.157158 105.331367 84.744835 105.928001 84.160118 106.753334 C 83.366341 106.634773 82.744972 106.287506 81.976753 105.712204 z",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a8efd539c034b0b5eb6874ccdf50cbe4.svg";
export { ForwardRef as ReactComponent };